import {gql,useQuery,useMutation,useLazyQuery}from'@apollo/client';import React,{useState,useMemo,useEffect,useRef,Fragment,useCallback}from'react';import PropTypes,{oneOf,shape,string,arrayOf}from'prop-types';import {Button,IconButton,ProductName,ProductPrice,ProductDetail,Badge,Icon}from'anf-core-react';function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _arrayWithHoles(r) {
  if (Array.isArray(r)) return r;
}
function _arrayWithoutHoles(r) {
  if (Array.isArray(r)) return _arrayLikeToArray(r);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
function _iterableToArray(r) {
  if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread2(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _regeneratorRuntime() {
  _regeneratorRuntime = function () {
    return e;
  };
  var t,
    e = {},
    r = Object.prototype,
    n = r.hasOwnProperty,
    o = Object.defineProperty || function (t, e, r) {
      t[e] = r.value;
    },
    i = "function" == typeof Symbol ? Symbol : {},
    a = i.iterator || "@@iterator",
    c = i.asyncIterator || "@@asyncIterator",
    u = i.toStringTag || "@@toStringTag";
  function define(t, e, r) {
    return Object.defineProperty(t, e, {
      value: r,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), t[e];
  }
  try {
    define({}, "");
  } catch (t) {
    define = function (t, e, r) {
      return t[e] = r;
    };
  }
  function wrap(t, e, r, n) {
    var i = e && e.prototype instanceof Generator ? e : Generator,
      a = Object.create(i.prototype),
      c = new Context(n || []);
    return o(a, "_invoke", {
      value: makeInvokeMethod(t, r, c)
    }), a;
  }
  function tryCatch(t, e, r) {
    try {
      return {
        type: "normal",
        arg: t.call(e, r)
      };
    } catch (t) {
      return {
        type: "throw",
        arg: t
      };
    }
  }
  e.wrap = wrap;
  var h = "suspendedStart",
    l = "suspendedYield",
    f = "executing",
    s = "completed",
    y = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  var p = {};
  define(p, a, function () {
    return this;
  });
  var d = Object.getPrototypeOf,
    v = d && d(d(values([])));
  v && v !== r && n.call(v, a) && (p = v);
  var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p);
  function defineIteratorMethods(t) {
    ["next", "throw", "return"].forEach(function (e) {
      define(t, e, function (t) {
        return this._invoke(e, t);
      });
    });
  }
  function AsyncIterator(t, e) {
    function invoke(r, o, i, a) {
      var c = tryCatch(t[r], t, o);
      if ("throw" !== c.type) {
        var u = c.arg,
          h = u.value;
        return h && "object" == typeof h && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) {
          invoke("next", t, i, a);
        }, function (t) {
          invoke("throw", t, i, a);
        }) : e.resolve(h).then(function (t) {
          u.value = t, i(u);
        }, function (t) {
          return invoke("throw", t, i, a);
        });
      }
      a(c.arg);
    }
    var r;
    o(this, "_invoke", {
      value: function (t, n) {
        function callInvokeWithMethodAndArg() {
          return new e(function (e, r) {
            invoke(t, n, e, r);
          });
        }
        return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
      }
    });
  }
  function makeInvokeMethod(e, r, n) {
    var o = h;
    return function (i, a) {
      if (o === f) throw Error("Generator is already running");
      if (o === s) {
        if ("throw" === i) throw a;
        return {
          value: t,
          done: !0
        };
      }
      for (n.method = i, n.arg = a;;) {
        var c = n.delegate;
        if (c) {
          var u = maybeInvokeDelegate(c, n);
          if (u) {
            if (u === y) continue;
            return u;
          }
        }
        if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) {
          if (o === h) throw o = s, n.arg;
          n.dispatchException(n.arg);
        } else "return" === n.method && n.abrupt("return", n.arg);
        o = f;
        var p = tryCatch(e, r, n);
        if ("normal" === p.type) {
          if (o = n.done ? s : l, p.arg === y) continue;
          return {
            value: p.arg,
            done: n.done
          };
        }
        "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg);
      }
    };
  }
  function maybeInvokeDelegate(e, r) {
    var n = r.method,
      o = e.iterator[n];
    if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
    var i = tryCatch(o, e.iterator, r.arg);
    if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y;
    var a = i.arg;
    return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
  }
  function pushTryEntry(t) {
    var e = {
      tryLoc: t[0]
    };
    1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
  }
  function resetTryEntry(t) {
    var e = t.completion || {};
    e.type = "normal", delete e.arg, t.completion = e;
  }
  function Context(t) {
    this.tryEntries = [{
      tryLoc: "root"
    }], t.forEach(pushTryEntry, this), this.reset(!0);
  }
  function values(e) {
    if (e || "" === e) {
      var r = e[a];
      if (r) return r.call(e);
      if ("function" == typeof e.next) return e;
      if (!isNaN(e.length)) {
        var o = -1,
          i = function next() {
            for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next;
            return next.value = t, next.done = !0, next;
          };
        return i.next = i;
      }
    }
    throw new TypeError(typeof e + " is not iterable");
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", {
    value: GeneratorFunctionPrototype,
    configurable: !0
  }), o(GeneratorFunctionPrototype, "constructor", {
    value: GeneratorFunction,
    configurable: !0
  }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) {
    var e = "function" == typeof t && t.constructor;
    return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name));
  }, e.mark = function (t) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t;
  }, e.awrap = function (t) {
    return {
      __await: t
    };
  }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () {
    return this;
  }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) {
    void 0 === i && (i = Promise);
    var a = new AsyncIterator(wrap(t, r, n, o), i);
    return e.isGeneratorFunction(r) ? a : a.next().then(function (t) {
      return t.done ? t.value : a.next();
    });
  }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () {
    return this;
  }), define(g, "toString", function () {
    return "[object Generator]";
  }), e.keys = function (t) {
    var e = Object(t),
      r = [];
    for (var n in e) r.push(n);
    return r.reverse(), function next() {
      for (; r.length;) {
        var t = r.pop();
        if (t in e) return next.value = t, next.done = !1, next;
      }
      return next.done = !0, next;
    };
  }, e.values = values, Context.prototype = {
    constructor: Context,
    reset: function (e) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t);
    },
    stop: function () {
      this.done = !0;
      var t = this.tryEntries[0].completion;
      if ("throw" === t.type) throw t.arg;
      return this.rval;
    },
    dispatchException: function (e) {
      if (this.done) throw e;
      var r = this;
      function handle(n, o) {
        return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o;
      }
      for (var o = this.tryEntries.length - 1; o >= 0; --o) {
        var i = this.tryEntries[o],
          a = i.completion;
        if ("root" === i.tryLoc) return handle("end");
        if (i.tryLoc <= this.prev) {
          var c = n.call(i, "catchLoc"),
            u = n.call(i, "finallyLoc");
          if (c && u) {
            if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
            if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
          } else if (c) {
            if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
          } else {
            if (!u) throw Error("try statement without catch or finally");
            if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
          }
        }
      }
    },
    abrupt: function (t, e) {
      for (var r = this.tryEntries.length - 1; r >= 0; --r) {
        var o = this.tryEntries[r];
        if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
          var i = o;
          break;
        }
      }
      i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
      var a = i ? i.completion : {};
      return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a);
    },
    complete: function (t, e) {
      if ("throw" === t.type) throw t.arg;
      return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y;
    },
    finish: function (t) {
      for (var e = this.tryEntries.length - 1; e >= 0; --e) {
        var r = this.tryEntries[e];
        if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y;
      }
    },
    catch: function (t) {
      for (var e = this.tryEntries.length - 1; e >= 0; --e) {
        var r = this.tryEntries[e];
        if (r.tryLoc === t) {
          var n = r.completion;
          if ("throw" === n.type) {
            var o = n.arg;
            resetTryEntry(r);
          }
          return o;
        }
      }
      throw Error("illegal catch attempt");
    },
    delegateYield: function (e, r, n) {
      return this.delegate = {
        iterator: values(e),
        resultName: r,
        nextLoc: n
      }, "next" === this.method && (this.arg = t), y;
    }
  }, e;
}
function _slicedToArray(r, e) {
  return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
}
function _taggedTemplateLiteral(e, t) {
  return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, {
    raw: {
      value: Object.freeze(t)
    }
  }));
}
function _toConsumableArray(r) {
  return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread();
}
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7;
gql(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  query Product($productId: String!) {\n    product(productId: $productId) {\n      id\n      productPageUrl\n    }\n  }\n"])));
gql(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  query Product($productId: String!) {\n    product(productId: $productId) {\n      badges {\n        text\n        theme\n      }\n      collection\n      defaultSwatchSequence\n      departmentName\n      id\n      imageSet {\n        primaryFaceOutImage\n        primaryHoverImage\n        prodImage\n        modelImage\n      }\n      kic\n      memberPrice {\n        description\n        originalPrice\n        discountText\n        variant\n      }\n      name\n      price {\n        description\n        originalPrice\n        discountPrice\n        discountText\n        variant\n      }\n      productPageUrl\n      shortDescriptors\n      swatchList {\n        id\n        name\n        sequence\n        swatchImage\n        product {\n          id\n          imageSet {\n            primaryFaceOutImage\n          }\n        }\n      }\n    }\n  }\n"])));
var TEXT_DATA = gql(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  query Text($pairKey: String!, $replacements: [String]) {\n    textFor {\n      pairWithReplacements(pairKey: $pairKey, replacements: $replacements) {\n        key\n        value\n      }\n    }\n  }\n"])));
var getProductDataQuery = gql(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  query Product($productId: String!) {\n    product(productId: $productId) {\n      id\n      productPageUrl\n    }\n  }\n"])));
var addToListMutation = gql(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\nmutation addToMySaves(\n  $productId: String!, \n  $kic: String!, \n  $collectionId: String, \n  $swatchSequence: String, \n  $longSku: String, \n  $colorCode: String\n) {\n  addToMySaves(\n    productId: $productId, \n    kic: $kic, \n    collectionId: $collectionId, \n    swatchSequence: $swatchSequence, \n    longSku: $longSku, \n    colorCode: $colorCode\n  ) {\n    success\n    isFirstTimeSave\n    errors {\n      message {\n          key\n          value\n      }\n      status\n    }\n  }\n}\n"])));
var removeFromListMutation = gql(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\nmutation removeFromMySaves(\n  $productId: String!, \n  $kic: String!, \n  $collectionId: String, \n  $swatchSequence: String, \n  $longSku: String, \n  $colorCode: String\n) {\n  removeFromMySaves(\n    productId: $productId, \n    kic: $kic, \n    collectionId: $collectionId, \n    swatchSequence: $swatchSequence, \n    longSku: $longSku, \n    colorCode: $colorCode\n  ) {\n    success\n    errors {\n      message {\n          key\n          value\n      }\n      status\n    }\n  }\n}\n"])));
var getStoreAttributeData = gql(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  query StoreAttribute {\n    config {\n      hasMfeMySavesEnabled: genericType(name: \"hasMfeMySavesEnabled\")\n    }\n  }\n"])));var EMPTY_TMNT = '??????';
var PRODUCT_CARD_URL_ANALYTICS_PARAMETERS = {
  pagefm: 'navigation-grid',
  prodvm: 'navigation-grid'
};
var PRODUCT_CARD_SWATCH_URL_ANALYTICS_PARAMETERS = {
  pagefm: 'navigation-swatch',
  prodvm: 'navigation-swatch'
};
var SMALLEST_POSSIBLE_BLANK_IMAGE = 'data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw';
var IMAGE_SIZE_POLICY = {
  XSMALL: 'xsmall',
  SMALL: 'small',
  MEDIUM: 'medium',
  LARGE: 'large',
  XLARGE: 'xlarge'
};
var API_TIMEOUT = 5000;
var SCROLL_THRESHOLD = '800px';//  @ts-check

/**
 * Returns the translated text for the given TMNT array.
 * Returns fallback text if query fails.
 * @param {String} pairKey - TMNT key to be translated.
 * @param {Object} options - Object of options for the query.
 * @param {Array} options.replacements - Array of replacements to be used in the query.
 * @param {String} options.fallback - English default text.
 * @param {Boolean} options.skip - Boolean to skip the query.
 * @returns {Object} Object of translated text for the given TMNT array.
 */
var useTranslatedText = function useTranslatedText() {
  var _textData$textFor;
  var pairKey = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
    replacements: [],
    fallback: '',
    skip: false
  };
  var _options$replacements = options.replacements,
    replacements = _options$replacements === void 0 ? [] : _options$replacements,
    _options$fallback = options.fallback,
    fallback = _options$fallback === void 0 ? '' : _options$fallback,
    _options$skip = options.skip,
    skip = _options$skip === void 0 ? false : _options$skip;
  var _useQuery = useQuery(TEXT_DATA, {
      variables: {
        pairKey: pairKey,
        replacements: replacements
      },
      skip: skip
    }),
    loading = _useQuery.loading,
    textData = _useQuery.data;
  var _ref = (textData === null || textData === void 0 || (_textData$textFor = textData.textFor) === null || _textData$textFor === void 0 ? void 0 : _textData$textFor.pairWithReplacements) || {},
    tmntKey = _ref.key,
    tmntValue = _ref.value;
  var resolvedTmntValue = tmntValue && tmntValue !== EMPTY_TMNT ? tmntValue : fallback;
  var translatedTextObject = {
    key: tmntKey || pairKey,
    value: resolvedTmntValue
  };
  if (loading) return {
    key: pairKey,
    value: ''
  };
  return translatedTextObject;
};var getMySavesFromLocalStorage = function getMySavesFromLocalStorage() {
  var savesListInStorage = localStorage.getItem('savesList');
  var mySavesObject = null;
  if (savesListInStorage) {
    mySavesObject = JSON.parse(savesListInStorage);
    if (mySavesObject.timeStamp <= new Date().getTime()) {
      mySavesObject = null;
    }
  }
  return mySavesObject;
};var fetchGuestSession = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(store) {
    var _AbortSignal;
    var response;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return fetch("/api/ecomm/".concat(store, "/session/guest"), _objectSpread2({
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            dataType: 'json'
          }, (_AbortSignal = AbortSignal) !== null && _AbortSignal !== void 0 && _AbortSignal.timeout ? {
            signal: AbortSignal.timeout(API_TIMEOUT)
          } : {}));
        case 2:
          response = _context.sent;
          if (response.ok) {
            _context.next = 5;
            break;
          }
          throw new Error("Network Error: ".concat(response.status, " ").concat(response.statusText, "."));
        case 5:
          return _context.abrupt("return", response.json());
        case 6:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function fetchGuestSession(_x) {
    return _ref.apply(this, arguments);
  };
}();/*! js-cookie v3.0.5 | MIT */
/* eslint-disable no-var */
function assign(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      target[key] = source[key];
    }
  }
  return target;
}
/* eslint-enable no-var */

/* eslint-disable no-var */
var defaultConverter = {
  read: function read(value) {
    if (value[0] === '"') {
      value = value.slice(1, -1);
    }
    return value.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent);
  },
  write: function write(value) {
    return encodeURIComponent(value).replace(/%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g, decodeURIComponent);
  }
};
/* eslint-enable no-var */

/* eslint-disable no-var */

function init(converter, defaultAttributes) {
  function set(name, value, attributes) {
    if (typeof document === 'undefined') {
      return;
    }
    attributes = assign({}, defaultAttributes, attributes);
    if (typeof attributes.expires === 'number') {
      attributes.expires = new Date(Date.now() + attributes.expires * 864e5);
    }
    if (attributes.expires) {
      attributes.expires = attributes.expires.toUTCString();
    }
    name = encodeURIComponent(name).replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent).replace(/[()]/g, escape);
    var stringifiedAttributes = '';
    for (var attributeName in attributes) {
      if (!attributes[attributeName]) {
        continue;
      }
      stringifiedAttributes += '; ' + attributeName;
      if (attributes[attributeName] === true) {
        continue;
      }

      // Considers RFC 6265 section 5.2:
      // ...
      // 3.  If the remaining unparsed-attributes contains a %x3B (";")
      //     character:
      // Consume the characters of the unparsed-attributes up to,
      // not including, the first %x3B (";") character.
      // ...
      stringifiedAttributes += '=' + attributes[attributeName].split(';')[0];
    }
    return document.cookie = name + '=' + converter.write(value, name) + stringifiedAttributes;
  }
  function get(name) {
    if (typeof document === 'undefined' || arguments.length && !name) {
      return;
    }

    // To prevent the for loop in the first place assign an empty array
    // in case there are no cookies at all.
    var cookies = document.cookie ? document.cookie.split('; ') : [];
    var jar = {};
    for (var i = 0; i < cookies.length; i++) {
      var parts = cookies[i].split('=');
      var value = parts.slice(1).join('=');
      try {
        var found = decodeURIComponent(parts[0]);
        jar[found] = converter.read(value, found);
        if (name === found) {
          break;
        }
      } catch (e) {}
    }
    return name ? jar[name] : jar;
  }
  return Object.create({
    set: set,
    get: get,
    remove: function remove(name, attributes) {
      set(name, '', assign({}, attributes, {
        expires: -1
      }));
    },
    withAttributes: function withAttributes(attributes) {
      return init(this.converter, assign({}, this.attributes, attributes));
    },
    withConverter: function withConverter(converter) {
      return init(assign({}, this.converter, converter), this.attributes);
    }
  }, {
    attributes: {
      value: Object.freeze(defaultAttributes)
    },
    converter: {
      value: Object.freeze(converter)
    }
  });
}
var api = init(defaultConverter, {
  path: '/'
});var useSessionCookies = function useSessionCookies() {
  var getCookies = function getCookies() {
    return api.get() || {};
  };
  var isStorePreview = function isStorePreview() {
    var cookies = getCookies();
    return !cookies ? false : Object.keys(cookies).some(function (key) {
      return key.includes('WCP');
    });
  };
  var getPersistentUserId = function getPersistentUserId(storeId) {
    var cookies = getCookies();
    var cookie = cookies.WCP_PERSISTENT || cookies.WC_PERSISTENT;
    if (!cookie) return null;
    var match = cookie.match(new RegExp("".concat(storeId, "_[-{0-9}]*[0-9]+")));
    if (!match) return null;
    var userId = match[0].split('_')[1];
    return userId !== '-1002' ? userId : null;
  };
  var pullUserIdAndStoreFromUserActivityCookie = function pullUserIdAndStoreFromUserActivityCookie(cookie) {
    return decodeURIComponent(cookie).split(',');
  };
  var getActiveUserId = function getActiveUserId(storeId) {
    var cookies = getCookies();
    var cookieSubKey = isStorePreview() ? 'WCP_USERACTIVITY' : 'WC_USERACTIVITY';
    var activityCookies = Object.entries(cookies).filter(function (_ref) {
      var _ref2 = _slicedToArray(_ref, 1),
        key = _ref2[0];
      return key.includes(cookieSubKey);
    }).map(function (_ref3) {
      var _ref4 = _slicedToArray(_ref3, 2),
        cookie = _ref4[1];
      return pullUserIdAndStoreFromUserActivityCookie(cookie);
    });
    if (!activityCookies.length) {
      return null;
    }
    var _ref5 = activityCookies.find(function (_ref7) {
        var _ref8 = _slicedToArray(_ref7, 2),
          currentStoreId = _ref8[1];
        return currentStoreId === (storeId === null || storeId === void 0 ? void 0 : storeId.toString());
      }) || [null],
      _ref6 = _slicedToArray(_ref5, 1),
      userId = _ref6[0];
    return userId === '-1002' ? null : userId;
  };
  var getSessionId = function getSessionId(storeId) {
    var _getPersistentUserId;
    return (_getPersistentUserId = getPersistentUserId(storeId)) !== null && _getPersistentUserId !== void 0 ? _getPersistentUserId : getActiveUserId(storeId);
  };
  return {
    getSessionId: getSessionId
  };
};/**
 * Custom hook to determine the user's state based on session and cookie data.
 *
 * @param {string} storeId - The store ID used to retrieve the session ID.
 * @returns {Object} An object containing functions to determine the user's state.
 * @returns {Function} return.isGenericUser - Checks if the user is a generic user.
 * @returns {Function} return.isLoggedIn - Checks if the user is logged in.
 * @returns {Function} return.isGuestUser - Checks if the user is a guest.
 */
var useUserState = function useUserState(storeId) {
  var _useSessionCookies = useSessionCookies(),
    getSessionId = _useSessionCookies.getSessionId;
  var userId = getSessionId(storeId);
  var isGeneric = !userId;
  var userType = api.get('userType');
  var isGenericUser = function isGenericUser() {
    return isGeneric;
  };
  var isLoggedIn = function isLoggedIn() {
    return !isGeneric && userType === 'R';
  };
  var isGuestUser = function isGuestUser() {
    return !isGeneric && !isLoggedIn();
  };
  return {
    isGenericUser: isGenericUser,
    isGuestUser: isGuestUser,
    isLoggedIn: isLoggedIn
  };
};/**
 * The purpose of this to resolve SSR issue with some code that relies on window being defined.
 */

var win;
if (typeof window !== 'undefined') {
  win = window;
} else {
  // NOTE: we may need to put some stuff in here in the future
  win = {};
}
var $window = win;function getSettings(addToList, removeFromList) {
  return {
    ADDING: {
      mutationToMake: addToList,
      listDataType: 'addToMySaves',
      analyticsVariation: 'addTo'
    },
    REMOVING: {
      mutationToMake: removeFromList,
      listDataType: 'removeFromMySaves',
      analyticsVariation: 'removeFrom'
    }
  };
}
var useUpdateMySaves = function useUpdateMySaves(_ref) {
  var _storeAttributeData$c;
  var productId = _ref.productId,
    kic = _ref.kic,
    collectionId = _ref.collectionId,
    swatchSequence = _ref.swatchSequence,
    longSku = _ref.longSku,
    colorCode = _ref.colorCode,
    price = _ref.price,
    brand = _ref.brand,
    categoryId = _ref.categoryId,
    name = _ref.name,
    isMiniGrid = _ref.isMiniGrid,
    mySavesItems = _ref.mySavesItems,
    refetch = _ref.refetch,
    store = _ref.store,
    storeId = _ref.storeId;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isCurrentProductSaved = _useState2[0],
    setIsCurrentProductSaved = _useState2[1];
  var _useState3 = useState(typeof mySavesItems[productId] !== 'undefined'),
    _useState4 = _slicedToArray(_useState3, 2),
    isSaved = _useState4[0],
    setSaved = _useState4[1];
  var _useQuery = useQuery(getStoreAttributeData),
    storeAttributeData = _useQuery.data;
  var hasMfeMySavesEnabled = storeAttributeData === null || storeAttributeData === void 0 || (_storeAttributeData$c = storeAttributeData.config) === null || _storeAttributeData$c === void 0 || (_storeAttributeData$c = _storeAttributeData$c.hasMfeMySavesEnabled) === null || _storeAttributeData$c === void 0 ? void 0 : _storeAttributeData$c.value;
  var _useUserState = useUserState(storeId),
    isGenericUser = _useUserState.isGenericUser;
  var _useMutation = useMutation(addToListMutation),
    _useMutation2 = _slicedToArray(_useMutation, 1),
    addToList = _useMutation2[0];
  var _useMutation3 = useMutation(removeFromListMutation),
    _useMutation4 = _slicedToArray(_useMutation3, 1),
    removeFromList = _useMutation4[0];
  var settings = useMemo(function () {
    return getSettings(addToList, removeFromList);
  }, [addToList, removeFromList]);
  useEffect(function () {
    if (!hasMfeMySavesEnabled) {
      var _mySavesObject$list;
      var mySavesObject = getMySavesFromLocalStorage();
      var savedStatus = !!(mySavesObject !== null && mySavesObject !== void 0 && (_mySavesObject$list = mySavesObject.list) !== null && _mySavesObject$list !== void 0 && _mySavesObject$list[productId]);
      setIsCurrentProductSaved(savedStatus);
    } else {
      setSaved(typeof mySavesItems[productId] !== 'undefined');
    }
  }, [hasMfeMySavesEnabled, productId, mySavesItems]);
  var sendAnalyticsData = function sendAnalyticsData(analyticTriggerVariation) {
    $window === null || $window === void 0 || $window.dispatchEvent(new CustomEvent("analytics.".concat(analyticTriggerVariation, "WishListSuccess"), {
      detail: {
        collectionId: collectionId,
        longSku: longSku,
        colorCode: colorCode
      }
    }));
    if ($window.digitalData) {
      var _price$priceFlag, _price$originalPrice, _price$discountPrice, _price$priceFlag2, _price$originalPrice2, _price$discountPrice2;
      var eventData = isMiniGrid ? {
        brand: brand !== null && brand !== void 0 ? brand : 'null',
        category_id: categoryId !== null && categoryId !== void 0 ? categoryId : 'null',
        collection_id: collectionId !== null && collectionId !== void 0 ? collectionId : 'null',
        key_item_color: kic !== null && kic !== void 0 ? kic : 'null',
        long_sku: 'null',
        price_flag: (_price$priceFlag = price.priceFlag) !== null && _price$priceFlag !== void 0 ? _price$priceFlag : 'null',
        price_list_local: (_price$originalPrice = price.originalPrice) !== null && _price$originalPrice !== void 0 ? _price$originalPrice : 'null',
        price_list_usd: 'null',
        price_offer_local: (_price$discountPrice = price.discountPrice) !== null && _price$discountPrice !== void 0 ? _price$discountPrice : 'null',
        price_offer_usd: 'null',
        product_id: productId !== null && productId !== void 0 ? productId : 'null',
        product_name: name !== null && name !== void 0 ? name : 'null',
        short_sku: 'null'
      } : {
        product_id: productId !== null && productId !== void 0 ? productId : 'null',
        collection_id: collectionId !== null && collectionId !== void 0 ? collectionId : 'null',
        price_flag: (_price$priceFlag2 = price.priceFlag) !== null && _price$priceFlag2 !== void 0 ? _price$priceFlag2 : 'null',
        key_item_color: kic !== null && kic !== void 0 ? kic : 'null',
        price_list_local: (_price$originalPrice2 = price.originalPrice) !== null && _price$originalPrice2 !== void 0 ? _price$originalPrice2 : 'null',
        price_offer_local: (_price$discountPrice2 = price.discountPrice) !== null && _price$discountPrice2 !== void 0 ? _price$discountPrice2 : 'null',
        short_sku: 'null',
        long_sku: longSku !== null && longSku !== void 0 ? longSku : 'null',
        product_name: name !== null && name !== void 0 ? name : 'null',
        price_list_usd: 'null',
        price_offer_usd: 'null'
      };
      $window.digitalData.trigger(analyticTriggerVariation === 'addTo' ? 'analytics.save_for_later' : 'analytics.remove_from_saves', eventData);
    }
  };
  var executeMutation = function executeMutation() {
    var setting = isSaved ? settings.REMOVING : settings.ADDING;
    setSaved(function (currIsSaved) {
      return !currIsSaved;
    });
    setting.mutationToMake({
      variables: {
        productId: productId,
        kic: kic,
        collectionId: collectionId,
        swatchSequence: swatchSequence,
        longSku: longSku,
        colorCode: colorCode
      },
      onCompleted: function () {
        var _onCompleted = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(data) {
          return _regeneratorRuntime().wrap(function _callee$(_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return refetch();
              case 2:
                if (setting.listDataType === 'addToMySaves') {
                  $window.dispatchEvent(new CustomEvent('crs:mySaveSuccess', {
                    detail: {
                      isFirstTimeSave: data[setting.listDataType].isFirstTimeSave
                    }
                  }));
                }
                sendAnalyticsData(setting.analyticsVariation);
              case 4:
              case "end":
                return _context.stop();
            }
          }, _callee);
        }));
        function onCompleted(_x) {
          return _onCompleted.apply(this, arguments);
        }
        return onCompleted;
      }(),
      onError: function onError() {
        setSaved(function (currIsSaved) {
          return !currIsSaved;
        });
      }
    });
  };
  var handleSavesClick = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _context2.prev = 0;
            if (!isGenericUser()) {
              _context2.next = 4;
              break;
            }
            _context2.next = 4;
            return fetchGuestSession(store);
          case 4:
            executeMutation();
            // eslint-disable-next-line no-empty
            _context2.next = 9;
            break;
          case 7:
            _context2.prev = 7;
            _context2.t0 = _context2["catch"](0);
          case 9:
          case "end":
            return _context2.stop();
        }
      }, _callee2, null, [[0, 7]]);
    }));
    return function handleSavesClick() {
      return _ref2.apply(this, arguments);
    };
  }();
  var handleSavesClickLegacy = function handleSavesClickLegacy() {
    var eventType = isCurrentProductSaved ? "mfe:productRemoveSave".concat(isMiniGrid ? 'MiniGrid' : '') : "mfe:productAddSave".concat(isMiniGrid ? 'MiniGrid' : '');
    var saveEvent = new CustomEvent(eventType, {
      detail: {
        productId: productId,
        kic: kic,
        collectionId: collectionId,
        swatchSequence: swatchSequence,
        longsku: '',
        colorCode: colorCode
      }
    });
    $window.dispatchEvent(saveEvent);
    if (isMiniGrid && $window.digitalData) {
      var _price$priceFlag3, _price$originalPrice3, _price$discountPrice3;
      var eventData = {
        brand: brand !== null && brand !== void 0 ? brand : 'null',
        category_id: categoryId !== null && categoryId !== void 0 ? categoryId : 'null',
        collection_id: collectionId !== null && collectionId !== void 0 ? collectionId : 'null',
        key_item_color: kic !== null && kic !== void 0 ? kic : 'null',
        long_sku: 'null',
        price_flag: (_price$priceFlag3 = price.priceFlag) !== null && _price$priceFlag3 !== void 0 ? _price$priceFlag3 : 'null',
        price_list_local: (_price$originalPrice3 = price.originalPrice) !== null && _price$originalPrice3 !== void 0 ? _price$originalPrice3 : 'null',
        price_list_usd: 'null',
        price_offer_local: (_price$discountPrice3 = price.discountPrice) !== null && _price$discountPrice3 !== void 0 ? _price$discountPrice3 : 'null',
        price_offer_usd: 'null',
        product_id: productId !== null && productId !== void 0 ? productId : 'null',
        product_name: name !== null && name !== void 0 ? name : 'null',
        short_sku: 'null'
      };
      $window.digitalData.trigger(isCurrentProductSaved ? 'analytics.remove_from_saves' : 'analytics.save_for_later', eventData);
    }
    setIsCurrentProductSaved(!isCurrentProductSaved);
  };
  return hasMfeMySavesEnabled ? {
    isSaved: isSaved,
    handleSavesClick: handleSavesClick
  } : {
    isSaved: isCurrentProductSaved,
    handleSavesClick: handleSavesClickLegacy
  };
};function getDefaultExportFromCjs (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}var classnames = {exports: {}};(function (module) {
  /* global define */

  (function () {

    var hasOwn = {}.hasOwnProperty;
    function classNames() {
      var classes = '';
      for (var i = 0; i < arguments.length; i++) {
        var arg = arguments[i];
        if (arg) {
          classes = appendClass(classes, parseValue(arg));
        }
      }
      return classes;
    }
    function parseValue(arg) {
      if (typeof arg === 'string' || typeof arg === 'number') {
        return arg;
      }
      if (_typeof(arg) !== 'object') {
        return '';
      }
      if (Array.isArray(arg)) {
        return classNames.apply(null, arg);
      }
      if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) {
        return arg.toString();
      }
      var classes = '';
      for (var key in arg) {
        if (hasOwn.call(arg, key) && arg[key]) {
          classes = appendClass(classes, key);
        }
      }
      return classes;
    }
    function appendClass(value, newClass) {
      if (!newClass) {
        return value;
      }
      if (value) {
        return value + ' ' + newClass;
      }
      return value + newClass;
    }
    if (module.exports) {
      classNames["default"] = classNames;
      module.exports = classNames;
    } else {
      window.classNames = classNames;
    }
  })();
})(classnames);
var classnamesExports = classnames.exports;
var classNames = /*@__PURE__*/getDefaultExportFromCjs(classnamesExports);/**
 * Returns provided URL string with provided query parameters appended
 *
 * @param {string} url - URL string to append query parameters to
 * @param {Object} [parameters={}] - Object of query parameters to append to url
 * @returns {string} URL string with appended query parameters, or original URL string if URL is
 * falsy or if parameters is empty
 * @example
 * // Returns '/shop/us/mens?pagefm=navigation-breadcrumbs'
 * addUrlParameters('/shop/us/mens', { pagefm: 'navigation-breadcrumbs' });
 * @example
* // Returns 'https://www.abercrombie.com/shop/us/p/90s-jeans?categoryId=12203&faceout=model&seq=99&pagefm=navigation-grid&prodvm=navigationgrid'
 * addUrlParameters('https://www.abercrombie.com/shop/us/p/90s-jeans?categoryId=12203&faceout=model&seq=99', { pagefm: 'navigation-grid', prodvm: 'navigation-grid' });
 */
var addUrlParameters = function addUrlParameters(url) {
  var parameters = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  if (!url) {
    return url;
  }
  var parametersString = Object.entries(parameters).reduce(function (string, _ref, i) {
    var _ref2 = _slicedToArray(_ref, 2),
      k = _ref2[0],
      v = _ref2[1];
    return "".concat(string).concat(i > 0 ? '&' : '').concat(k, "=").concat(v);
  }, '');
  if (!parametersString) {
    return url;
  }
  return "".concat(url).concat(url.includes('?') ? '&' : '?').concat(parametersString);
};var miniGridStyle = {"miniGrid":"xp-9-5-0__miniGrid-module__miniGrid--b61sk","spotlightCard":"xp-9-5-0__miniGrid-module__spotlightCard--Uf4x4"};var CLICK_BEHAVIORS = {
  productPage: 'productPage',
  quickview: 'quickview'
};
var productCardClickBehaviorType = oneOf([].concat(_toConsumableArray(Object.values(CLICK_BEHAVIORS)), ['', undefined]));var style = {"productCard":"xp-9-5-0__productCard-module__productCard--hiGkO","template":"xp-9-5-0__productCard-module__template--UsV8l","content":"xp-9-5-0__productCard-module__content--gm314","product-details-wrapper":"xp-9-5-0__productCard-module__product-details-wrapper--Ogb8e","product-content-link":"xp-9-5-0__productCard-module__product-content-link--rJH1s","product-detail":"xp-9-5-0__productCard-module__product-detail--je7H5","save":"xp-9-5-0__productCard-module__save--kQ9Vg","badges":"xp-9-5-0__productCard-module__badges--dvSHM","buttons":"xp-9-5-0__productCard-module__buttons--q4Pat","cardFade":"xp-9-5-0__productCard-module__cardFade--H1WFJ","swatches":"xp-9-5-0__productCard-module__swatches--R6sC-","noHover":"xp-9-5-0__productCard-module__noHover--26Byl","swatchLength":"xp-9-5-0__productCard-module__swatchLength--J2Cap","quickview":"xp-9-5-0__productCard-module__quickview--pYUfs","socialProofingBadgeContainer":"xp-9-5-0__productCard-module__socialProofingBadgeContainer--FVsJ9","topBadge":"xp-9-5-0__productCard-module__topBadge--tozfu","hover":"xp-9-5-0__productCard-module__hover--NcwMS","hasHoverImage":"xp-9-5-0__productCard-module__hasHoverImage--xpGBA","productCardImage_1":"xp-9-5-0__productCard-module__productCardImage_1--qxbCl","productCardImage_2":"xp-9-5-0__productCard-module__productCardImage_2--ZPFak","badgeSeparator":"xp-9-5-0__productCard-module__badgeSeparator--eMv-h","anf":"xp-9-5-0__productCard-module__anf--Foo23","kids":"xp-9-5-0__productCard-module__kids--WPyAw","hol":"xp-9-5-0__productCard-module__hol--avqc-","defaultBadge":"xp-9-5-0__productCard-module__defaultBadge--hm-ww","earlyAccessBadge":"xp-9-5-0__productCard-module__earlyAccessBadge--ftKRB","product-image-section":"xp-9-5-0__productCard-module__product-image-section--rvCr2"};function useBreakpointSizes() {
  var _useState = useState({
      xxsmall: false,
      xsmall: false,
      small: false,
      medium: false,
      large: false,
      xlarge: false,
      xxlarge: false
    }),
    _useState2 = _slicedToArray(_useState, 2),
    breakpoints = _useState2[0],
    setBreakpoints = _useState2[1];
  useEffect(function () {
    var updateSize = function updateSize() {
      var width = window.innerWidth;
      setBreakpoints({
        xxsmall: width > 360,
        xsmall: width > 540,
        small: width > 700,
        medium: width > 825,
        large: width > 1025,
        xlarge: width > 1200,
        xxlarge: width > 1500
      });
    };
    updateSize();
    window.addEventListener('resize', updateSize);
    return function () {
      return window.removeEventListener('resize', updateSize);
    };
  }, []);
  return breakpoints;
}var imageSetType = shape({
  primaryFaceOutImage: string.isRequired,
  primaryHoverImage: string,
  prodImage: string,
  modelImage: string,
  lifestyleImage: string
});var mySavesItemType = PropTypes.shape({
  id: PropTypes.shape({
    productId: PropTypes.string,
    kic: PropTypes.string,
    sku: PropTypes.string
  })
});var priceType = shape({
  description: string.isRequired,
  discountPrice: string,
  discountText: string,
  originalPrice: string.isRequired,
  variant: string.isRequired
});var promoMessageType = shape({
  type: string,
  message: string
});var swatchType = shape({
  id: string,
  name: string,
  product: shape({
    id: string,
    imageSet: imageSetType
  }),
  swatchImage: string
});var productType = shape({
  id: string.isRequired,
  imageSet: imageSetType.isRequired,
  name: string.isRequired,
  price: priceType.isRequired,
  promoMessaging: promoMessageType,
  badges: arrayOf(shape({
    text: string,
    theme: string
  })),
  collection: string,
  defaultSwatchSequence: string,
  departmentName: string,
  kic: string,
  memberPrice: priceType,
  partNumber: string,
  similarKeyword: string,
  productPageUrl: string,
  shortDescriptors: arrayOf(string),
  socialProofMessage: string,
  swatchList: arrayOf(swatchType)
});var productCardSharedProps = {
  algonomyOnClickAnalytics: PropTypes.shape({
    placementObj: PropTypes.shape({
      id: PropTypes.string,
      name: PropTypes.string,
      treatments: PropTypes.arrayOf(PropTypes.shape({
        control: PropTypes.bool,
        testId: PropTypes.number,
        testType: PropTypes.string,
        treatmentId: PropTypes.string,
        treatmentName: PropTypes.string
      })).isRequired
    }),
    productIndex: PropTypes.number
  }),
  brand: PropTypes.string.isRequired,
  className: PropTypes.string,
  clickBehavior: productCardClickBehaviorType,
  deferImageLoad: PropTypes.bool,
  hasModelImagery: PropTypes.bool,
  hasProdImagery: PropTypes.bool,
  hasSwatchHover: PropTypes.bool,
  hasHyperlinkShortDescriptor: PropTypes.bool,
  hadSwatchInteraction: PropTypes.bool,
  imageHostName: PropTypes.string.isRequired,
  isDesktop: PropTypes.bool,
  isMfeQuickview: PropTypes.bool,
  isMiniGrid: PropTypes.bool,
  isMiniGridSpotlightCard: PropTypes.bool,
  noImageFoundImgUrl: PropTypes.string.isRequired,
  onSwatchInteraction: PropTypes.func,
  product: productType.isRequired,
  shouldSetVisitedProduct: PropTypes.bool
};
var productCardDataWrapperProps = _objectSpread2(_objectSpread2({}, productCardSharedProps), {}, {
  mySavesItems: mySavesItemType,
  refetch: PropTypes.func,
  store: PropTypes.string.isRequired,
  storeId: PropTypes.string.isRequired
});
var productCardProps = _objectSpread2(_objectSpread2({}, productCardSharedProps), {}, {
  categoryId: PropTypes.string,
  handleSavesClick: PropTypes.func.isRequired,
  text: PropTypes.shape({
    elementChangeWarning: PropTypes.shape({
      key: PropTypes.string,
      value: PropTypes.string
    }),
    quickViewLabel: PropTypes.shape({
      key: PropTypes.string,
      value: PropTypes.string
    }),
    saveButtonSave: PropTypes.shape({
      key: PropTypes.string,
      value: PropTypes.string
    }),
    saveButtonSaved: PropTypes.shape({
      key: PropTypes.string,
      value: PropTypes.string
    })
  }).isRequired
});
var productCardButtons = {
  isSaved: PropTypes.bool,
  onQuickViewClick: PropTypes.func,
  onSaveClick: PropTypes.func,
  showQuickView: PropTypes.bool,
  isDesktop: PropTypes.bool
};
var productCardImages = {
  forceLifestyleImage: PropTypes.bool,
  imageSet: imageSetType.isRequired,
  hoveredSwatch: swatchType,
  imageHostName: PropTypes.string,
  noImageFoundImgUrl: PropTypes.string,
  hasModelImagery: PropTypes.bool,
  hasProdImagery: PropTypes.bool,
  onClick: PropTypes.func,
  productName: PropTypes.string,
  productPageUrl: PropTypes.string,
  selectedSwatchName: PropTypes.string,
  showPlaceholder: PropTypes.bool
};
var productDetailsSection = {
  badges: PropTypes.arrayOf(PropTypes.shape({
    text: PropTypes.string,
    theme: PropTypes.string
  })),
  hyperlinkShortDescriptorsFlag: PropTypes.bool,
  memberPrice: priceType,
  price: priceType,
  productName: PropTypes.string,
  promoMessaging: promoMessageType,
  shortDescriptors: PropTypes.arrayOf(PropTypes.string),
  brand: PropTypes.string,
  departmentName: PropTypes.string,
  showHyperlinkShortDescriptors: PropTypes.bool,
  handleProductCardClick: PropTypes.func,
  productPageUrl: PropTypes.string
};
var productSwatches = {
  hasSwatchHover: PropTypes.bool,
  handleSwatchHover: PropTypes.func,
  imageHostName: PropTypes.string,
  isDesktop: PropTypes.bool,
  limitSwatches: PropTypes.bool,
  productId: PropTypes.string,
  productName: PropTypes.string,
  productPageUrl: PropTypes.string,
  showPlaceholder: PropTypes.bool,
  swatchList: PropTypes.arrayOf(swatchType)
};
var socialProofBadge = {
  socialProofMessage: PropTypes.string,
  brand: PropTypes.string,
  isDesktop: PropTypes.bool
};
var swatchTileGroup = {
  children: PropTypes.node.isRequired,
  legend: PropTypes.node.isRequired,
  hasVisibleLegend: PropTypes.bool,
  horizontalAlignment: PropTypes.oneOf(['left', 'center', 'right']),
  layout: PropTypes.oneOf(['', '2-up', '3-up', '4-up', '5-up', '6-up']),
  size: PropTypes.oneOf(['default', 'small']),
  verticalAlignment: PropTypes.oneOf(['top', 'middle', 'bottom'])
};
var swatchTile = {
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  image: PropTypes.string,
  isChecked: PropTypes.bool,
  /** Makes label into screen-reader text. To be replaced with aria-label on <input>.
     */
  isLabelVisible: PropTypes.bool,
  label: PropTypes.string,
  onChange: PropTypes.func,
  onClick: PropTypes.func,
  showPlaceholder: PropTypes.bool,
  state: PropTypes.string,
  handleSwatchHover: PropTypes.func,
  swatch: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
    product: PropTypes.shape({
      id: PropTypes.string,
      imageSet: PropTypes.shape({
        primaryFaceOutImage: PropTypes.string
      })
    })
  })
};
var productCardShortDescriptor = {
  brand: PropTypes.string,
  departmentName: PropTypes.string,
  shortDescriptors: PropTypes.arrayOf(PropTypes.string).isRequired,
  hyperlinkShortDescriptorsFlag: PropTypes.bool
};
var productCardBadge = {
  text: PropTypes.string.isRequired,
  theme: PropTypes.string
};
var productCardDetails = {
  price: priceType,
  productName: PropTypes.string,
  promoMessaging: promoMessageType,
  memberPrice: priceType,
  productNameSize: PropTypes.string
};
var productCardLink = {
  children: PropTypes.node.isRequired,
  url: PropTypes.string.isRequired,
  onClick: PropTypes.func
};
var productCardQuickviewButton = {
  onClick: PropTypes.func.isRequired,
  isDesktop: PropTypes.bool
};function ProductCardQuickviewButton(_ref) {
  var onClick = _ref.onClick,
    isDesktop = _ref.isDesktop,
    label = _ref.label;
  var icon = 'zoom';
  var _useBreakpointSizes = useBreakpointSizes(),
    small = _useBreakpointSizes.small,
    medium = _useBreakpointSizes.medium;
  if (medium) {
    return /*#__PURE__*/React.createElement(Button, {
      classList: "product-card__button--qv-aui ".concat(style.quickview),
      onClick: onClick,
      theme: "inverse",
      variant: "overlay"
    }, isDesktop ? /*#__PURE__*/React.createElement("span", {
      "data-icon": icon
    }) : null, /*#__PURE__*/React.createElement("span", {
      "data-aui": "product-card-qv-button-text"
    }, label));
  }
  if (small) {
    return /*#__PURE__*/React.createElement(IconButton, {
      classList: "product-card__button--qv-aui",
      icon: icon,
      labelText: label,
      onClick: onClick,
      theme: "inverse"
    });
  }
  return null;
}
ProductCardQuickviewButton.propTypes = productCardQuickviewButton;function ProductCardSaveButton(_ref) {
  var saved = _ref.saved,
    onClick = _ref.onClick,
    saveLabel = _ref.saveLabel,
    savedLabel = _ref.savedLabel;
  var className = classNames('product-my-saves', style.save);
  var dataState = saved ? 'saved' : 'unsaved';
  var label = saved ? savedLabel : saveLabel;
  var icon = saved ? 'heart-filled' : 'heart';
  return /*#__PURE__*/React.createElement("div", {
    className: className,
    "data-state": dataState,
    "data-testid": "catalog-product-card-save-button"
  }, /*#__PURE__*/React.createElement(IconButton, {
    icon: icon,
    labelText: label,
    onClick: onClick,
    theme: "inverse"
  }));
}
ProductCardSaveButton.propTypes = {
  saved: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
  saveLabel: PropTypes.string.isRequired,
  savedLabel: PropTypes.string.isRequired
};function ProductCardButtons(_ref) {
  var _ref$isSaved = _ref.isSaved,
    isSaved = _ref$isSaved === void 0 ? false : _ref$isSaved,
    _ref$onQuickViewClick = _ref.onQuickViewClick,
    onQuickViewClick = _ref$onQuickViewClick === void 0 ? function () {} : _ref$onQuickViewClick,
    _ref$onSaveClick = _ref.onSaveClick,
    onSaveClick = _ref$onSaveClick === void 0 ? function () {} : _ref$onSaveClick,
    _ref$showQuickView = _ref.showQuickView,
    showQuickView = _ref$showQuickView === void 0 ? true : _ref$showQuickView,
    _ref$isDesktop = _ref.isDesktop,
    isDesktop = _ref$isDesktop === void 0 ? false : _ref$isDesktop,
    quickViewLabel = _ref.quickViewLabel,
    saveLabel = _ref.saveLabel,
    savedLabel = _ref.savedLabel;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ProductCardSaveButton, {
    onClick: onSaveClick,
    saved: isSaved,
    saveLabel: saveLabel.value,
    savedLabel: savedLabel.value
  }), /*#__PURE__*/React.createElement("div", {
    className: classNames(style.buttons, {
      'screen-reader-text': !showQuickView
    }),
    "data-aui": "product-card-buttons",
    "data-testid": "catalog-product-card-quickview-button"
  }, /*#__PURE__*/React.createElement(ProductCardQuickviewButton, {
    onClick: onQuickViewClick,
    isDesktop: isDesktop,
    label: quickViewLabel.value
  })));
}
ProductCardButtons.propTypes = productCardButtons;/**
 * Constructs an image URL with optional image size parameter.
 *
 * @param {string} imageHostName - The image hostname prefix to the URL
 * @param {string} imageId - The image identifier such as KIC_XXX_XXX_XXX.
 * @param {string} [imageSize] - The desired image size such as 'medium' or 'small'.
 * @returns {string} The generated image URL.
 */
var getImageUrl = function getImageUrl(imageHostName, imageId, imageSize) {
  var imageUrl = "".concat(imageHostName, "/is/image/anf/").concat(imageId, "?");
  var params = new URLSearchParams();
  params.append('policy', "product-".concat(imageSize !== null && imageSize !== void 0 ? imageSize : IMAGE_SIZE_POLICY.MEDIUM));
  return imageUrl + params.toString();
};// https://stackoverflow.com/questions/9815762/detect-when-an-image-fails-to-load-in-javascript
var tryImageLoad = function tryImageLoad(url) {
  return new Promise(function (resolve, reject) {
    var img = new Image();
    img.addEventListener('load', function () {
      return resolve();
    });
    img.addEventListener('error', function () {
      return reject();
    });
    img.src = url;
  });
};function ProductCardImages(_ref) {
  var _ref$forceLifestyleIm = _ref.forceLifestyleImage,
    forceLifestyleImage = _ref$forceLifestyleIm === void 0 ? false : _ref$forceLifestyleIm,
    _ref$hasModelImagery = _ref.hasModelImagery,
    hasModelImagery = _ref$hasModelImagery === void 0 ? false : _ref$hasModelImagery,
    _ref$hasProdImagery = _ref.hasProdImagery,
    hasProdImagery = _ref$hasProdImagery === void 0 ? false : _ref$hasProdImagery,
    _ref$hoveredSwatch = _ref.hoveredSwatch,
    hoveredSwatch = _ref$hoveredSwatch === void 0 ? null : _ref$hoveredSwatch,
    _ref$imageSet = _ref.imageSet,
    primaryFaceOutImage = _ref$imageSet.primaryFaceOutImage,
    primaryHoverImage = _ref$imageSet.primaryHoverImage,
    prodImage = _ref$imageSet.prodImage,
    modelImage = _ref$imageSet.modelImage,
    lifestyleImage = _ref$imageSet.lifestyleImage,
    _ref$imageHostName = _ref.imageHostName,
    imageHostName = _ref$imageHostName === void 0 ? '' : _ref$imageHostName,
    _ref$noImageFoundImgU = _ref.noImageFoundImgUrl,
    noImageFoundImgUrl = _ref$noImageFoundImgU === void 0 ? '' : _ref$noImageFoundImgU,
    _ref$onClick = _ref.onClick,
    onClick = _ref$onClick === void 0 ? function () {} : _ref$onClick,
    _ref$productName = _ref.productName,
    productName = _ref$productName === void 0 ? '' : _ref$productName,
    _ref$productPageUrl = _ref.productPageUrl,
    productPageUrl = _ref$productPageUrl === void 0 ? null : _ref$productPageUrl,
    _ref$selectedSwatchNa = _ref.selectedSwatchName,
    selectedSwatchName = _ref$selectedSwatchNa === void 0 ? null : _ref$selectedSwatchNa,
    _ref$showPlaceholder = _ref.showPlaceholder,
    showPlaceholder = _ref$showPlaceholder === void 0 ? false : _ref$showPlaceholder;
  var productCardLink = useRef(null);
  var primaryImageRef = useRef();
  var secondaryImageRef = useRef();
  var hasHoverImage = primaryHoverImage !== primaryFaceOutImage;

  // if we have no hope of displaying these images let's not even try
  if (!noImageFoundImgUrl || !imageHostName) return null;
  var computedPrimaryFaceOutImage = function computedPrimaryFaceOutImage() {
    if (hasModelImagery) {
      return modelImage || primaryFaceOutImage;
    }
    if (hasProdImagery) {
      return prodImage || primaryFaceOutImage;
    }
    if (forceLifestyleImage) {
      return lifestyleImage || primaryFaceOutImage;
    }
    return primaryFaceOutImage;
  };
  // Try prodImage, otherwise use the No Image Found image
  // Choosing not to tryImageLoad elsewhere because
  // most of the time images should load successfully
  var handleOnError = function handleOnError(imageRef) {
    var currentImageRef = imageRef.current;
    if (!currentImageRef) return;
    currentImageRef.onerror = null; // prevents looping
    var prodImageUrl = getImageUrl(imageHostName, prodImage, IMAGE_SIZE_POLICY.MEDIUM);
    tryImageLoad(prodImageUrl).then(function () {
      currentImageRef.src = prodImageUrl;
    })["catch"](function () {
      tryImageLoad(noImageFoundImgUrl).then(function () {
        currentImageRef.src = noImageFoundImgUrl;
      })
      // eslint-disable-next-line no-console
      ["catch"](function () {
        return console.log('No image could be loaded');
      });
    });
  };
  var computeImageUrl = function computeImageUrl(isPrimary) {
    var imageId;
    if (hoveredSwatch) {
      imageId = hoveredSwatch.product.imageSet.primaryFaceOutImage;
    } else {
      imageId = !isPrimary && primaryHoverImage ? primaryHoverImage : computedPrimaryFaceOutImage();
    }
    return showPlaceholder ? SMALLEST_POSSIBLE_BLANK_IMAGE : getImageUrl(imageHostName, imageId, IMAGE_SIZE_POLICY.MEDIUM);
  };
  var computeAltText = function computeAltText(isPrimary) {
    var altText = productName;
    if (hoveredSwatch) {
      altText = "".concat(productName, ", ").concat(hoveredSwatch.name);
    } else if (selectedSwatchName) {
      altText = "".concat(productName, ", ").concat(selectedSwatchName);
    }
    return "".concat(altText, " view ").concat(isPrimary ? '1' : '2');
  };
  var computeDataAuiText = function computeDataAuiText(isPrimary) {
    var dataAuiText = '';
    if (isPrimary) {
      dataAuiText = 'product-card-image';
    } else {
      dataAuiText = hoveredSwatch ? 'product-card-hovered-swatch-image' : 'product-card-hover-image';
    }
    return dataAuiText;
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(hasHoverImage ? style.hasHoverImage : '')
  }, /*#__PURE__*/React.createElement("a", {
    ref: productCardLink,
    href: addUrlParameters(productPageUrl, PRODUCT_CARD_URL_ANALYTICS_PARAMETERS),
    onClick: onClick
  }, /*#__PURE__*/React.createElement("img", {
    ref: primaryImageRef,
    alt: computeAltText(true),
    className: style.productCardImage_1,
    "data-aui": computeDataAuiText(true),
    "data-testid": "catalog-product-card-image",
    onError: function onError() {
      return handleOnError(primaryImageRef);
    },
    src: computeImageUrl(true),
    width: "400"
  }), hasHoverImage && /*#__PURE__*/React.createElement("img", {
    ref: secondaryImageRef,
    alt: computeAltText(false),
    className: style.productCardImage_2,
    "data-aui": computeDataAuiText(false),
    onError: function onError() {
      return handleOnError(secondaryImageRef);
    },
    src: computeImageUrl(false),
    width: "400"
  })));
}
ProductCardImages.propTypes = productCardImages;function ProductCardBadge(_ref) {
  var text = _ref.text,
    _ref$theme = _ref.theme,
    theme = _ref$theme === void 0 ? undefined : _ref$theme;
  return /*#__PURE__*/React.createElement("div", {
    className: theme === 'earlyAccess' ? style.earlyAccessBadge : style.defaultBadge
  }, text);
}
ProductCardBadge.propTypes = productCardBadge;function ProductCardBadges(_ref) {
  var badges = _ref.badges;
  var badgeElements = [];
  badges.forEach(function (_ref2) {
    var text = _ref2.text,
      theme = _ref2.theme;
    // Omit badges with insufficient data
    if (text && theme) {
      badgeElements.push( /*#__PURE__*/React.createElement(React.Fragment, {
        key: text
      }, badgeElements.length > 0 && /*#__PURE__*/React.createElement("span", {
        className: style.badgeSeparator
      }, ' | '), /*#__PURE__*/React.createElement(ProductCardBadge, {
        text: text,
        theme: theme
      })));
    }
  });
  if (badgeElements.length === 0) {
    return null;
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(style.badges)
  }, badgeElements);
}
ProductCardBadges.propTypes = {
  badges: PropTypes.arrayOf(PropTypes.shape({
    text: PropTypes.string,
    theme: PropTypes.string
  })).isRequired
};function ProductCardDetails(_ref) {
  var _ref$memberPrice = _ref.memberPrice,
    memberPrice = _ref$memberPrice === void 0 ? undefined : _ref$memberPrice,
    price = _ref.price,
    _ref$productName = _ref.productName,
    productName = _ref$productName === void 0 ? '' : _ref$productName,
    _ref$promoMessaging = _ref.promoMessaging,
    promoMessaging = _ref$promoMessaging === void 0 ? undefined : _ref$promoMessaging,
    _ref$productNameSize = _ref.productNameSize,
    productNameSize = _ref$productNameSize === void 0 ? undefined : _ref$productNameSize;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ProductName, {
    size: productNameSize
  }, /*#__PURE__*/React.createElement("h2", {
    "data-aui": "product-card-name",
    "data-testid": "catalog-product-card-name"
  }, productName)), /*#__PURE__*/React.createElement(ProductPrice, {
    description: price.description,
    discountPrice: price === null || price === void 0 ? void 0 : price.discountPrice,
    discountText: price === null || price === void 0 ? void 0 : price.discountText,
    originalPrice: price.originalPrice,
    variant: price.variant
  }), memberPrice && /*#__PURE__*/React.createElement(ProductPrice, {
    description: memberPrice.description,
    discountText: memberPrice.discountText,
    originalPrice: memberPrice.originalPrice,
    variant: memberPrice.variant
  }), (promoMessaging === null || promoMessaging === void 0 ? void 0 : promoMessaging.message) && /*#__PURE__*/React.createElement(ProductDetail, {
    variant: "small"
  }, /*#__PURE__*/React.createElement("div", {
    className: "promo-badge"
  }, /*#__PURE__*/React.createElement("span", {
    className: "promo-info--".concat(promoMessaging.type === 'tiered' ? 'bogo' : promoMessaging.type)
  }, promoMessaging.message))));
}
ProductCardDetails.propTypes = productCardDetails;function ProductCardLink(_ref) {
  var children = _ref.children,
    _ref$onClick = _ref.onClick,
    onClick = _ref$onClick === void 0 ? function () {} : _ref$onClick,
    url = _ref.url;
  return /*#__PURE__*/React.createElement("a", {
    className: style['product-content-link'],
    href: addUrlParameters(url, PRODUCT_CARD_URL_ANALYTICS_PARAMETERS),
    onClick: onClick
  }, children);
}
ProductCardLink.propTypes = productCardLink;var filterHyperlinkShortDescriptors = function filterHyperlinkShortDescriptors(shortDescriptors, whitelist) {
  var filteredHyperlinkShortDescriptors = [];
  shortDescriptors.forEach(function (formattedShortDescriptor) {
    var lowercaseShortDescriptor = formattedShortDescriptor.toLowerCase();
    if (whitelist.has(lowercaseShortDescriptor)) {
      filteredHyperlinkShortDescriptors.push({
        text: formattedShortDescriptor,
        url: whitelist.get(lowercaseShortDescriptor)
      });
    }
  });
  return filteredHyperlinkShortDescriptors;
};var data = {
  anf: {
    'men\'s': {
      list1: {
        'best dressed guest collection': '/shop/us/mens-best-dressed-guest-weddings-and-events',
        'a&f x trevor project': '/shop/us/pride',
        'gender inclusive': '/shop/us/lookbook-a-and-f-lookbook',
        'trend edit': '/shop/us/search?filtered=true&rows=90&searchTerm=Trend+Edit&start=0&departmentId=12202-ANF',
        'online exclusive': '/shop/us/search?filtered=true&rows=90&searchTerm=Online+Exclusive&start=0&departmentId=12202-ANF',
        'matching set': '/shop/us/mens-coordinated-sets',
        'getaway shop': '/shop/us/mens-summer-clothes',
        'vol. 28': '/shop/us/search?departmentCategoryId=12202-ANF&searchTerm=Vol.+28',
        'golf shop': '/shop/us/mens-golf-shop',
        'for justice collection': '/shop/us/search?departmentCategoryId=12202-ANF&searchTerm=For+Justice+Collection'
      },
      list2: {
        '6 inch | 15 cm': '/shop/us/search?departmentCategoryId=12202-ANF&searchTerm=6+inch',
        'a&f vintage stretch denim': '/shop/us/search?departmentCategoryId=12202-ANF&searchTerm=A%26F+Vintage+Stretch+Denim',
        'a&f signature stretch denim': '/shop/us/search?departmentCategoryId=12202-ANF&searchTerm=A%26F+Signature+Stretch+Denim',
        'a&f authentic rigid denim': '/shop/us/search?departmentCategoryId=12202-ANF&searchTerm=Authentic+Rigid+Denim',
        'a&f basic stretch denim': '/shop/us/search?departmentCategoryId=12202-ANF&searchTerm=basic+stretch+Denim',
        'a&f signature stretch twill': '/shop/us/search?departmentCategoryId=12202-ANF&searchTerm=Signature+Stretch+Twill',
        '7 inch | 18 cm': '/shop/us/search?departmentCategoryId=12202-ANF&searchTerm=7+inch',
        '9 inch | 23 cm': '/shop/us/search?departmentCategoryId=12202-ANF&searchTerm=9+inch',
        '3 inch | 7 cm': '/shop/us/search?departmentCategoryId=12202-ANF&searchTerm=3+inch'
      }
    },
    'women\'s': {
      list1: {
        'best dressed guest collection': '/shop/us/womens-best-dressed-guest-weddings-and-events',
        'a&f x trevor project': '/shop/us/pride',
        'gender inclusive': '/shop/us/lookbook-a-and-f-lookbook',
        'trend edit': '/shop/us/search?filtered=true&rows=90&searchTerm=Trend+Edit&start=0&departmentId=12203-ANF',
        'online exclusive': '/shop/us/search?filtered=true&rows=90&searchTerm=Online+Exclusive&start=0&departmentId=12203-ANF',
        'matching set': '/shop/us/womens-matching-sets-dresses-and-rompers',
        'getaway shop': '/shop/us/womens-summer-clothes',
        'vol. 28': '/shop/us/search?departmentCategoryId=12202-ANF&searchTerm=Vol.+28',
        'premium footwear collection': '/shop/us/search?departmentCategoryId=12203-ANF&searchTerm=premium+footwear+collection',
        'abercrombie x tia booth': '/shop/womens-abercrombie-x-tia-booth-new-arrivals',
        'for justice collection': '/shop/us/search?filtered=true&rows=90&searchTerm=For+Justice+Collection&start=0&departmentId=12203-ANF'
      },
      list2: {
        'a&f all day comfort stretch denim': '/shop/us/search?departmentCategoryId=12203-ANF&searchTerm=A%26F+All+Day+Comfort+Stretch+Denim',
        'a&f signature stretch denim': '/shop/us/search?departmentCategoryId=12203-ANF&searchTerm=A%26F+Signature+Stretch+Denim',
        'a&f vintage stretch denim': '/shop/us/search?departmentCategoryId=12203-ANF&searchTerm=A%26F+Vintage+Stretch+Denim',
        'authentic rigid denim': '/shop/us/search?departmentCategoryId=12203-ANF&searchTerm=Authentic+Rigid+Denim',
        'hold-you-in stretch denim': '/shop/us/search?departmentCategoryId=12203-ANF&searchTerm=Hold-You-In+Stretch+Denim'
      }
    }
  },
  kids: {
    boys: {
      list1: {
        'online exclusive': '/shop/us/search?filtered=true&rows=90&searchTerm=online+exclusive&start=0&departmentId=179205-KIDS',
        'matching set': '/shop/us/kids/boys-matching-sets',
        'the cool stuff': '/shop/us/search?filtered=true&rows=90&searchTerm=THE+COOL+STUFF&start=0&departmentId=179205-KIDS',
        'vol. 28': '/shop/us/search?departmentCategoryId=179205-KIDS&searchTerm=Vol.+28',
        'everybody collection': '/shop/us/kids/kids-everybody-collection'
      },
      list2: {}
    },
    girls: {
      list1: {
        'online exclusive': '/shop/us/search?filtered=true&rows=90&searchTerm=online+exclusive&start=0&departmentId=179206-KIDS',
        'matching set': '/shop/us/kids/girls-matching-sets',
        'the cool stuff': '/shop/us/search?filtered=true&rows=90&searchTerm=THE+COOL+STUFF&start=0&departmentId=179206-KIDS',
        'vol. 28': '/shop/us/search?departmentCategoryId=179206-KIDS&searchTerm=Vol.+28',
        'everybody collection': '/shop/us/kids/kids-everybody-collection'
      },
      list2: {}
    }
  },
  hol: {
    'men\'s': {
      list1: {
        'pride collection': '/shop/us/pride-collection',
        'gender inclusive': '/shop/us/search?filtered=true&rows=90&searchTerm=gender+inclusive&start=0&departmentId=12551-HOL',
        'online exclusive': '/shop/us/search?filtered=true&rows=90&searchTerm=online+exclusive&start=0&departmentId=12551-HOL',
        'must-have collection': '/shop/us/mens-must-have-collection',
        'all day gameplay': '/shop/us/mens-all-day-gameplay',
        'part of a matching set': '/shop/us/search?departmentCategoryId=12551-HOL&searchTerm=part+of+a+matching+set'
      },
      list2: {}
    },
    'women\'s': {
      list1: {
        'pride collection': '/shop/us/pride-collection',
        'gender inclusive': '/shop/us/search?filtered=true&rows=90&searchTerm=gender+inclusive&start=0&departmentId=12552-HOL',
        'online exclusive': '/shop/us/search?filtered=true&rows=90&searchTerm=online+exclusive&start=0&departmentId=12552-HOL',
        'all day gameplay': '/shop/us/mens-all-day-gameplay',
        'part of a matching set': '/shop/us/womens-matching-sets'
      },
      list2: {
        'built in shorts': '/shop/us/search?departmentCategoryId=12552-HOL&searchTerm=Built+in+Shorts',
        'i have pockets': '/shop/us/search?departmentCategoryId=12552-HOL&searchTerm=I+have+pockets',
        'classic stretch': '/shop/us/search?departmentCategoryId=12552-HOL&searchTerm=Classic+Stretch',
        'advanced stretch': '/shop/us/search?departmentCategoryId=12552-HOL&searchTerm=Advanced+Stretch',
        'soft stretch': '/shop/us/search?departmentCategoryId=12552-HOL&searchTerm=Soft+Stretch'
      }
    }
  },
  gh: {
    'men\'s': {
      list1: {
        'pride collection': '/shop/us/gilly-hicks/pride-collection',
        'gender inclusive': '/shop/us/gilly-hicks/unisex',
        'online exclusive': '/shop/us/search?filtered=true&rows=90&searchTerm=online+exclusive&start=0&departmentId=65014360-GH',
        'part of a matching set': '/shop/us/search?filtered=true&rows=90&searchTerm=part+of+a+matching+set&start=0&departmentId=65014360-GH'
      },
      list2: {}
    },
    'women\'s': {
      list1: {
        'pride collection': '/shop/us/gilly-hicks/pride-collection',
        'gender inclusive': '/shop/us/gilly-hicks/unisex',
        'online exclusive': '/shop/us/search?filtered=true&rows=90&searchTerm=online+exclusive&start=0&departmentId=65014366-GH',
        'part of a matching set': '/shop/us/search?filtered=true&rows=90&searchTerm=part+of+a+matching+set&start=0&departmentId=65014366-GH'
      },
      list2: {}
    }
  },
  st: {
    'men\'s': {
      list1: {
        'gender inclusive': '/shop/us/social-tourist/shop-all-unisex',
        'online exclusive': '/shop/us/search?filtered=true&rows=90&searchTerm=online+exclusive&start=0&departmentId=65014738-ST'
      },
      list2: {}
    },
    'women\'s': {
      list1: {
        'gender inclusive': '/shop/us/social-tourist/shop-all-unisex',
        'online exclusive': '/shop/us/search?filtered=true&rows=90&searchTerm=online+exclusive&start=0&departmentId=65014738-ST'
      },
      list2: {}
    }
  }
};
var jsonToMap = function jsonToMap(json) {
  return new Map(Object.entries(json));
};

/**
 * @param {string} testSegment
 * @returns {Map<string, Map<string, Map<string, string>}
 */
var computeWhitelist = function computeWhitelist(testSegment) {
  var whitelist = new Map();
  Object.entries(data).forEach(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
      brandKey = _ref2[0],
      brandValue = _ref2[1];
    var brandMap = new Map();
    Object.entries(brandValue).forEach(function (_ref3) {
      var _ref4 = _slicedToArray(_ref3, 2),
        deptKey = _ref4[0],
        deptValue = _ref4[1];
      var list1 = deptValue.list1,
        list2 = deptValue.list2;
      var list = testSegment === 'C' ? _objectSpread2(_objectSpread2({}, list1), list2) : list1;
      var deptMap = jsonToMap(list);
      brandMap.set(deptKey, deptMap);
    });
    whitelist.set(brandKey, brandMap);
  });
  return whitelist;
};
var whitelistB = computeWhitelist('B');
var whitelistC = computeWhitelist('C');

/**
 * @param {string} brand
 * @param {string} deptName
 * @param {string} testSegment
 * @returns {Map<string, string>}
 */
var getDepartmentWhitelist = function getDepartmentWhitelist(brand, deptName, testSegment) {
  var whitelist = testSegment === 'C' ? whitelistC : whitelistB;
  if (whitelist.has(brand) && whitelist.get(brand).has(deptName)) {
    return whitelist.get(brand).get(deptName);
  }
  return new Map();
};function ProductCardShortDescriptor(_ref) {
  var _ref$brand = _ref.brand,
    brand = _ref$brand === void 0 ? '' : _ref$brand,
    _ref$departmentName = _ref.departmentName,
    departmentName = _ref$departmentName === void 0 ? '' : _ref$departmentName,
    shortDescriptors = _ref.shortDescriptors,
    hyperlinkShortDescriptorsFlag = _ref.hyperlinkShortDescriptorsFlag;
  if (hyperlinkShortDescriptorsFlag) {
    var whitelist = getDepartmentWhitelist(brand, departmentName, hyperlinkShortDescriptorsFlag);
    var filteredHyperlinkShortDescriptors = filterHyperlinkShortDescriptors(shortDescriptors, whitelist);
    if (filteredHyperlinkShortDescriptors.length > 0) {
      /**
       * Using the `text` as a key is problematic iff the same short descriptor is entered
       * for both shortDescriptor1 & shortDescriptor2 in PIM
       * This makes the assumption that that will never be the case
       */
      var shortDescriptorContent = filteredHyperlinkShortDescriptors.map(function (_ref2, index) {
        var text = _ref2.text,
          url = _ref2.url;
        return /*#__PURE__*/React.createElement(Fragment, {
          key: text
        }, index > 0 && ' | ', /*#__PURE__*/React.createElement("a", {
          href: url
        }, text));
      });
      return /*#__PURE__*/React.createElement(ProductDetail, {
        variant: "small"
      }, shortDescriptorContent);
    }
    return null;
  }
  return /*#__PURE__*/React.createElement(ProductDetail, {
    variant: "small"
  }, shortDescriptors.join(' | '));
}
ProductCardShortDescriptor.propTypes = productCardShortDescriptor;function ProductDetailsSection(_ref) {
  var badges = _ref.badges,
    hyperlinkShortDescriptorsFlag = _ref.hyperlinkShortDescriptorsFlag,
    memberPrice = _ref.memberPrice,
    price = _ref.price,
    productName = _ref.productName,
    promoMessaging = _ref.promoMessaging,
    shortDescriptors = _ref.shortDescriptors,
    brand = _ref.brand,
    departmentName = _ref.departmentName,
    showHyperlinkShortDescriptors = _ref.showHyperlinkShortDescriptors,
    handleProductCardClick = _ref.handleProductCardClick,
    productPageUrl = _ref.productPageUrl;
  return /*#__PURE__*/React.createElement("div", {
    className: style['product-details-wrapper']
  }, /*#__PURE__*/React.createElement(ProductCardLink, {
    onClick: handleProductCardClick,
    url: productPageUrl
  }, /*#__PURE__*/React.createElement(ProductCardBadges, {
    badges: badges !== null && badges !== void 0 ? badges : []
  }), /*#__PURE__*/React.createElement(ProductCardDetails, {
    memberPrice: memberPrice,
    price: price,
    productName: productName,
    promoMessaging: promoMessaging
  }), !showHyperlinkShortDescriptors && (shortDescriptors === null || shortDescriptors === void 0 ? void 0 : shortDescriptors.length) > 0 && /*#__PURE__*/React.createElement(ProductCardShortDescriptor, {
    brand: brand,
    departmentName: departmentName,
    shortDescriptors: shortDescriptors,
    hyperlinkShortDescriptorsFlag: hyperlinkShortDescriptorsFlag
  })), showHyperlinkShortDescriptors && (shortDescriptors === null || shortDescriptors === void 0 ? void 0 : shortDescriptors.length) > 0 && /*#__PURE__*/React.createElement(ProductCardShortDescriptor, {
    brand: brand,
    departmentName: departmentName,
    shortDescriptors: shortDescriptors
  }));
}
ProductDetailsSection.propTypes = productDetailsSection;function SwatchTile(_ref) {
  var id = _ref.id,
    _ref$image = _ref.image,
    image = _ref$image === void 0 ? undefined : _ref$image,
    _ref$isChecked = _ref.isChecked,
    isChecked = _ref$isChecked === void 0 ? false : _ref$isChecked,
    _ref$isLabelVisible = _ref.isLabelVisible,
    isLabelVisible = _ref$isLabelVisible === void 0 ? true : _ref$isLabelVisible,
    _ref$label = _ref.label,
    label = _ref$label === void 0 ? undefined : _ref$label,
    name = _ref.name,
    _ref$onChange = _ref.onChange,
    onChange = _ref$onChange === void 0 ? undefined : _ref$onChange,
    _ref$onClick = _ref.onClick,
    onClick = _ref$onClick === void 0 ? undefined : _ref$onClick,
    _ref$showPlaceholder = _ref.showPlaceholder,
    showPlaceholder = _ref$showPlaceholder === void 0 ? true : _ref$showPlaceholder,
    _ref$state = _ref.state,
    state = _ref$state === void 0 ? undefined : _ref$state,
    type = _ref.type,
    value = _ref.value,
    swatch = _ref.swatch,
    handleSwatchHover = _ref.handleSwatchHover;
  var preLoadedImage = showPlaceholder ? SMALLEST_POSSIBLE_BLANK_IMAGE : image;
  var inputBehaviorProp = typeof onChange === 'function' ? {
    onChange: onChange
  } : {
    readOnly: true
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "swtg-input-inner-wrapper",
    "data-state": state,
    "data-testid": "catalog-product-card-swatch-tile",
    onBlur: function onBlur() {
      return handleSwatchHover(null);
    },
    onFocus: function onFocus() {
      return handleSwatchHover(swatch);
    },
    onMouseOut: function onMouseOut() {
      return handleSwatchHover(null);
    },
    onMouseOver: function onMouseOver() {
      return handleSwatchHover(swatch);
    }
  }, /*#__PURE__*/React.createElement("input", _extends({
    checked: isChecked,
    className: "swtg-input",
    id: id,
    name: name,
    onClick: onClick,
    type: type,
    value: value
    // eslint-disable-next-line react/jsx-props-no-spreading
  }, inputBehaviorProp)), /*#__PURE__*/React.createElement("div", {
    className: "swtg-input-tile-wrapper"
  }, /*#__PURE__*/React.createElement("div", {
    className: "swtg-image-outer-wrapper"
  }, /*#__PURE__*/React.createElement("div", {
    className: "swtg-image-inner-wrapper",
    style: isChecked ? {
      border: '2px solid #374e62'
    } : {}
  }, /*#__PURE__*/React.createElement("img", {
    alt: "",
    "data-testid": "catalog-product-card-swatch-tile-image",
    src: preLoadedImage,
    width: "19"
  }))), /*#__PURE__*/React.createElement("label", {
    className: label && isLabelVisible ? 'swtg-label' : 'screen-reader-text',
    "data-label-visible": label && isLabelVisible ? 'true' : 'false',
    htmlFor: id
  }, label)));
}
SwatchTile.propTypes = swatchTile;/**
 * A React component for rendering HTML content from TMNTs.
 *
 * **Important:** User-provided data must never be passed to this component
 *
 * @param {Object} props - The component props.
 * @param {string} props.property - The TMNT key.
 * @param {string} props.value - The HTML string to be rendered.
 * @returns {JSX.Element} A span element with the rendered HTML content.
 */
function TmntHtml(_ref) {
  var property = _ref.property,
    value = _ref.value;
  return /*#__PURE__*/React.createElement("span", {
    dangerouslySetInnerHTML: {
      __html: value
    },
    "data-property": property
  });
}
TmntHtml.propTypes = {
  property: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired
};function SwatchTileGroup(_ref) {
  var children = _ref.children,
    elementChangeWarning = _ref.elementChangeWarning,
    _ref$hasVisibleLegend = _ref.hasVisibleLegend,
    hasVisibleLegend = _ref$hasVisibleLegend === void 0 ? false : _ref$hasVisibleLegend,
    _ref$horizontalAlignm = _ref.horizontalAlignment,
    horizontalAlignment = _ref$horizontalAlignm === void 0 ? null : _ref$horizontalAlignm,
    _ref$layout = _ref.layout,
    layout = _ref$layout === void 0 ? null : _ref$layout,
    legend = _ref.legend,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'default' : _ref$size,
    _ref$verticalAlignmen = _ref.verticalAlignment,
    verticalAlignment = _ref$verticalAlignmen === void 0 ? null : _ref$verticalAlignmen;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("h2", {
    "aria-live": "assertive",
    className: "screen-reader-text"
  }, /*#__PURE__*/React.createElement(TmntHtml, {
    property: elementChangeWarning.key || '',
    value: elementChangeWarning.value || ''
  })), /*#__PURE__*/React.createElement("div", {
    className: "swatch-tile-group",
    "data-horizontal-alignment": horizontalAlignment,
    "data-layout": layout,
    "data-size": size,
    "data-testid": "swatch-tile-group",
    "data-vertical-alignment": verticalAlignment
  }, /*#__PURE__*/React.createElement("fieldset", null, /*#__PURE__*/React.createElement("legend", {
    className: hasVisibleLegend ? 'h4' : 'screen-reader-text'
  }, legend), /*#__PURE__*/React.createElement("div", {
    className: "swtg-input-outer-wrapper",
    "data-testid": "swtg-input-outer-wrapper"
  }, children))));
}
SwatchTileGroup.propTypes = swatchTileGroup;var DESKTOP_SWATCH_LIMIT = 6;
var MOBILE_SWATCH_LIMIT = 4;
var getSwatchLimit = function getSwatchLimit(isDesktop) {
  return isDesktop ? DESKTOP_SWATCH_LIMIT : MOBILE_SWATCH_LIMIT;
};function ProductSwatches(_ref) {
  var _ref$handleSwatchHove = _ref.handleSwatchHover,
    handleSwatchHover = _ref$handleSwatchHove === void 0 ? function () {} : _ref$handleSwatchHove,
    _ref$hasSwatchHover = _ref.hasSwatchHover,
    hasSwatchHover = _ref$hasSwatchHover === void 0 ? false : _ref$hasSwatchHover,
    elementChangeWarning = _ref.elementChangeWarning,
    imageHostName = _ref.imageHostName,
    _ref$isDesktop = _ref.isDesktop,
    isDesktop = _ref$isDesktop === void 0 ? false : _ref$isDesktop,
    _ref$limitSwatches = _ref.limitSwatches,
    limitSwatches = _ref$limitSwatches === void 0 ? false : _ref$limitSwatches,
    productPageUrl = _ref.productPageUrl,
    productId = _ref.productId,
    productName = _ref.productName,
    _ref$showPlaceholder = _ref.showPlaceholder,
    showPlaceholder = _ref$showPlaceholder === void 0 ? true : _ref$showPlaceholder,
    swatchList = _ref.swatchList,
    handleSwatchClick = _ref.handleSwatchClick;
  var swatchLimit = getSwatchLimit(isDesktop);
  var swatchTiles = swatchList.map(function (swatch) {
    return /*#__PURE__*/React.createElement(Fragment, {
      key: swatch.id
    }, imageHostName && /*#__PURE__*/React.createElement(SwatchTile, {
      handleSwatchHover: handleSwatchHover,
      id: "".concat(productId, "__").concat(swatch.id, "__swatch"),
      image: getImageUrl(imageHostName, swatch.swatchImage, IMAGE_SIZE_POLICY.XSMALL),
      isChecked: swatch.product.id === productId,
      isLabelVisible: false,
      label: "".concat(swatch.name, " swatch"),
      name: productId,
      onClick: function onClick(e) {
        return handleSwatchClick(e.currentTarget.value);
      },
      showPlaceholder: showPlaceholder,
      swatch: swatch,
      type: "button",
      value: swatch.product.id
    }));
  });
  var getAdditionalSwatchCount = function getAdditionalSwatchCount() {
    var additionalSwatchText = "+".concat(swatchList.length - swatchLimit);
    return isDesktop ? /*#__PURE__*/React.createElement("div", {
      className: style.swatchLength
    }, additionalSwatchText) : /*#__PURE__*/React.createElement("a", {
      className: style.swatchLength,
      href: productPageUrl
    }, additionalSwatchText);
  };
  return /*#__PURE__*/React.createElement("div", {
    className: classNames(style.swatches, _defineProperty({}, style.noHover, hasSwatchHover)),
    "data-aui": "product-card-swatches"
  }, /*#__PURE__*/React.createElement(SwatchTileGroup, {
    legend: "".concat(productName, " swatches"),
    elementChangeWarning: elementChangeWarning
  }, swatchTiles.slice(0, limitSwatches ? Math.min(swatchLimit, swatchTiles.length) : swatchTiles.length), limitSwatches && swatchList.length > swatchLimit && getAdditionalSwatchCount()));
}
ProductSwatches.propTypes = productSwatches;function SocialProofBadge(_ref) {
  var _ref$brand = _ref.brand,
    brand = _ref$brand === void 0 ? 'anf' : _ref$brand,
    _ref$isDesktop = _ref.isDesktop,
    isDesktop = _ref$isDesktop === void 0 ? false : _ref$isDesktop,
    _ref$socialProofMessa = _ref.socialProofMessage,
    socialProofMessage = _ref$socialProofMessa === void 0 ? '' : _ref$socialProofMessa;
  if (!socialProofMessage || brand === 'hol' && !isDesktop) return null;
  return /*#__PURE__*/React.createElement("div", {
    className: style.socialProofingBadgeContainer
  }, /*#__PURE__*/React.createElement(Badge, null, /*#__PURE__*/React.createElement(Icon, {
    icon: "flame-filled"
  }), socialProofMessage));
}
SocialProofBadge.propTypes = socialProofBadge;/**
 * Get the current page type from $window.digitalData
 * Only be called from an event handler
 * Otherwise needs to be wrapped in a useEffect
 * @returns {String} Name of current page type
 */
var getPageType = function getPageType() {
  var _$window$digitalData;
  var pageType = $window === null || $window === void 0 || (_$window$digitalData = $window.digitalData) === null || _$window$digitalData === void 0 ? void 0 : _$window$digitalData.get('page.pageKind' );
  return typeof pageType === 'string' ? pageType.replace(/ /g, '_') : '';
};/**
 * @name collectOnClickAnalyticsData
 * @public
 * @description Function receives the user click event object on product card,
 * packages analytics data and returns it.
 *
 * @param {Object} placement - the focused placement contain the clicked product
 * @param {Object} productIndex - the index of the product within the placements array
 *
 * @return {Object} - Returns the onClick analytics data object
 */
var collectOnClickAnalyticsData = function collectOnClickAnalyticsData(placement, productIndex) {
  var _window;
  var id = placement.id,
    name = placement.name,
    treatments = placement.treatments;
  var onLoadData = ((_window = window) === null || _window === void 0 || (_window = _window.digitalData) === null || _window === void 0 ? void 0 : _window.get('algonomy.onLoad', {})) || {};
  var processedTreatments = treatments.reduce(function (acc, item) {
    acc.push(_objectSpread2(_objectSpread2({}, item), {}, {
      control: item.control === null ? '' : item.control,
      testId: item.testId === null ? '' : item.testId
    }));
    return acc;
  }, []);
  return _objectSpread2(_objectSpread2({}, onLoadData), {}, {
    placement: id,
    position: productIndex,
    strategyName: name,
    mvtTreatments: processedTreatments
  });
};

/**
 * @name runAnalyticsOnClick
 * @public
 * @description Function to initiate the analytics onClick data bridge events
 *
 * @param {Object} data - The analytics data to pass with the data bridge events
 */
var runAnalyticsOnClick = function runAnalyticsOnClick(data) {
  var _window3;
  if (!((_window3 = window) !== null && _window3 !== void 0 && _window3.digitalData)) return;
  window.digitalData.set('algonomy.onClick', data);
};var buildTreatments = function buildTreatments(treatment) {
  var _treatment$control, _treatment$testId;
  return _objectSpread2(_objectSpread2({}, treatment), {}, {
    control: (_treatment$control = treatment.control) !== null && _treatment$control !== void 0 ? _treatment$control : '',
    testId: (_treatment$testId = treatment.testId) !== null && _treatment$testId !== void 0 ? _treatment$testId : ''
  });
};
var runAnalyticsForQuickView = function runAnalyticsForQuickView(_ref) {
  var _placementObj$treatme, _placementObj$treatme2;
  var placementObj = _ref.placementObj,
    productIndex = _ref.productIndex;
  if (!placementObj || typeof productIndex === 'undefined') {
    return;
  }
  var analyticsData = collectOnClickAnalyticsData({
    id: placementObj.id,
    name: placementObj.name,
    treatments: (_placementObj$treatme = (_placementObj$treatme2 = placementObj.treatments) === null || _placementObj$treatme2 === void 0 ? void 0 : _placementObj$treatme2.map(buildTreatments)) !== null && _placementObj$treatme !== void 0 ? _placementObj$treatme : []
  }, productIndex);
  runAnalyticsOnClick(analyticsData);
};var dataText = 'swatch_hover';
var eventType = 'click';
var triggerDigitalData = function triggerDigitalData(eventName) {
  var eventDetails = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  $window.digitalData.trigger(eventName, eventDetails);
};
var setDigitalData = function setDigitalData(dataKey, data) {
  $window.digitalData.set(dataKey, data);
};
var triggerHoverAnalytics = function triggerHoverAnalytics() {
  triggerDigitalData("".concat(getPageType(), "_").concat(dataText, "_").concat(eventType), {
    event_type: eventType,
    data_text: dataText,
    data_action: 'hover'
  });
};
var triggerQuickviewAnalytics = function triggerQuickviewAnalytics(_ref) {
  var algonomyOnClickAnalytics = _ref.algonomyOnClickAnalytics,
    categoryId = _ref.categoryId,
    isMiniGrid = _ref.isMiniGrid,
    socialProofMessage = _ref.socialProofMessage;
  runAnalyticsForQuickView(algonomyOnClickAnalytics);
  if (socialProofMessage) {
    setDigitalData('product.afSource', 'social proofing');
  } else {
    // Unset data in case it was set previously
    setDigitalData('product.afSource', undefined);
  }
  if (isMiniGrid && categoryId) {
    setDigitalData('product.productViewMethod', "mini grid - ".concat(categoryId));
    setDigitalData('page.pageViewMethod', 'modal - quick view');
    var analyticsQVEvent = new CustomEvent('analytics.quick_view');
    triggerDigitalData(analyticsQVEvent);
  }
};
var triggerMiniGridAnalytics = function triggerMiniGridAnalytics(categoryId) {
  setDigitalData('product.productViewMethod', "mini grid - ".concat(categoryId));
  setDigitalData('page.pageViewMethod', 'page load');
  var analyticsPDEvent = new CustomEvent('analytics.product_detail');
  triggerDigitalData(analyticsPDEvent);
};var loadImage = function loadImage() {
  var imageUrl = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var fetchPriority = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  return new Promise(function (resolve, reject) {
    var img = document.createElement('img');
    if (fetchPriority) img.fetchPriority = fetchPriority;
    img.onload = function () {
      resolve(img);
    };
    img.onerror = function () {
      reject(imageUrl);
    };
    img.onabort = function () {
      reject(imageUrl);
    };
    img.src = imageUrl;
  });
};

// https://stackoverflow.com/questions/42615556/how-to-preload-images-in-react-js
// Added fetchPriority to try to make sure PFO images load before others on scroll
var loadImages = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
    var imageUrls,
      fetchPriority,
      imagePromises,
      _args = arguments;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          imageUrls = _args.length > 0 && _args[0] !== undefined ? _args[0] : [];
          fetchPriority = _args.length > 1 && _args[1] !== undefined ? _args[1] : '';
          imagePromises = [];
          imageUrls.forEach(function (imageUrl) {
            imagePromises.push(loadImage(imageUrl, fetchPriority));
          });
          return _context.abrupt("return", Promise.allSettled(imagePromises));
        case 5:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function loadImages() {
    return _ref.apply(this, arguments);
  };
}();var isBrowser = typeof window !== 'undefined';var useIntersection = function useIntersection(ref, options) {
  var _a = useState(null),
    intersectionObserverEntry = _a[0],
    setIntersectionObserverEntry = _a[1];
  useEffect(function () {
    if (ref.current && typeof IntersectionObserver === 'function') {
      var handler = function handler(entries) {
        setIntersectionObserverEntry(entries[0]);
      };
      var observer_1 = new IntersectionObserver(handler, options);
      observer_1.observe(ref.current);
      return function () {
        setIntersectionObserverEntry(null);
        observer_1.disconnect();
      };
    }
    return function () {};
  }, [ref.current, options.threshold, options.root, options.rootMargin]);
  return intersectionObserverEntry;
};var useSessionStorage = function useSessionStorage(key, initialValue, raw) {
  if (!isBrowser) {
    return [initialValue, function () {}];
  }
  // eslint-disable-next-line react-hooks/rules-of-hooks
  var _a = useState(function () {
      try {
        var sessionStorageValue = sessionStorage.getItem(key);
        if (typeof sessionStorageValue !== 'string') {
          sessionStorage.setItem(key, raw ? String(initialValue) : JSON.stringify(initialValue));
          return initialValue;
        } else {
          return raw ? sessionStorageValue : JSON.parse(sessionStorageValue || 'null');
        }
      } catch (_a) {
        // If user is in private mode or has storage restriction
        // sessionStorage can throw. JSON.parse and JSON.stringify
        // can throw, too.
        return initialValue;
      }
    }),
    state = _a[0],
    setState = _a[1];
  // eslint-disable-next-line react-hooks/rules-of-hooks
  useEffect(function () {
    try {
      var serializedState = raw ? String(state) : JSON.stringify(state);
      sessionStorage.setItem(key, serializedState);
    } catch (_a) {
      // If user is in private mode or has storage restriction
      // sessionStorage can throw. Also JSON.stringify can throw.
    }
  });
  return [state, setState];
};var useFirstScrollIntoView = function useFirstScrollIntoView(onFirstScrollIntoView) {
  var ref = useRef();
  var intersection = useIntersection(ref, {
    root: null,
    rootMargin: "".concat(SCROLL_THRESHOLD, " 0px ").concat(SCROLL_THRESHOLD, " 0px"),
    threshold: 0
  });
  var hasScrolledIntoView = useRef();
  useEffect(function () {
    if (!hasScrolledIntoView.current && intersection !== null && intersection !== void 0 && intersection.isIntersecting && onFirstScrollIntoView) {
      onFirstScrollIntoView();
      hasScrolledIntoView.current = true;
    }
  }, [intersection, onFirstScrollIntoView]);
  return {
    ref: ref
  };
};var useImagePreloading = function useImagePreloading(swatchList, imageHostName, imageSet, setIsHovered, setHeight, isDesktop, hasSwatchHover) {
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    imagesLoaded = _useState2[0],
    setImagesLoaded = _useState2[1];
  var swatchLimit = getSwatchLimit(isDesktop);

  // On first scroll into view:
  // Load all swatch tile images
  // Load first `swatchLimit` swatch PFO images
  // Load product's PFO and PH images
  var _useFirstScrollIntoVi = useFirstScrollIntoView(imageHostName ? /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var swatchImageUrls, primaryFaceOutUrls, secondaryImageUrls;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            swatchImageUrls = [];
            if (isDesktop) {
              swatchList.forEach(function (swatch, index) {
                swatchImageUrls.push(getImageUrl(imageHostName, swatch.swatchImage, IMAGE_SIZE_POLICY.XSMALL));
                if (!hasSwatchHover && index < swatchLimit) {
                  swatchImageUrls.push(getImageUrl(imageHostName, swatch.product.imageSet.primaryFaceOutImage, IMAGE_SIZE_POLICY.MEDIUM));
                }
              });
            }
            primaryFaceOutUrls = [getImageUrl(imageHostName, imageSet.primaryFaceOutImage, IMAGE_SIZE_POLICY.MEDIUM)];
            secondaryImageUrls = [getImageUrl(imageHostName, imageSet.primaryHoverImage, IMAGE_SIZE_POLICY.MEDIUM)].concat(swatchImageUrls);
            Promise.allSettled([loadImages(primaryFaceOutUrls, 'High'), loadImages(secondaryImageUrls)]).then(function () {
              return setImagesLoaded(true);
            });
          case 5:
          case "end":
            return _context.stop();
        }
      }, _callee);
    })) : null),
    productCardRef = _useFirstScrollIntoVi.ref;

  // On first hover or focus, load PFO images for remaining swatches
  var hasPreloadedAdditionalPrimaryImages = useRef(false);
  var preloadAdditionalPrimaryImages = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
      var swatchImageUrls;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            if (!(isDesktop && !hasPreloadedAdditionalPrimaryImages.current && imageHostName)) {
              _context2.next = 7;
              break;
            }
            if (hasSwatchHover) {
              _context2.next = 6;
              break;
            }
            hasPreloadedAdditionalPrimaryImages.current = true;
            swatchImageUrls = swatchList.slice(Math.min(swatchLimit, swatchList.length)).map(function (swatch) {
              return getImageUrl(imageHostName, swatch.product.imageSet.primaryFaceOutImage, IMAGE_SIZE_POLICY.MEDIUM);
            });
            _context2.next = 6;
            return loadImages(swatchImageUrls);
          case 6:
            setHeight(productCardRef.current.scrollHeight);
          case 7:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function preloadAdditionalPrimaryImages() {
      return _ref2.apply(this, arguments);
    };
  }();
  var setIsHoveredWithImagePreloading = function setIsHoveredWithImagePreloading(value) {
    if (value) {
      preloadAdditionalPrimaryImages();
    }
    setIsHovered(value);
  };
  return {
    productCardRef: productCardRef,
    setIsHoveredWithImagePreloading: setIsHoveredWithImagePreloading,
    imagesLoaded: imagesLoaded
  };
};var useQuickViewEvent = function useQuickViewEvent(_ref) {
  var algonomyOnClickAnalytics = _ref.algonomyOnClickAnalytics,
    isMfeQuickview = _ref.isMfeQuickview,
    isMiniGrid = _ref.isMiniGrid,
    categoryId = _ref.categoryId,
    _ref$product = _ref.product,
    collection = _ref$product.collection,
    defaultSwatchSequence = _ref$product.defaultSwatchSequence,
    productId = _ref$product.productId,
    imageSet = _ref$product.imageSet,
    productName = _ref$product.productName,
    socialProofMessage = _ref$product.socialProofMessage,
    brand = _ref.brand,
    faceoutImageType = _ref.faceoutImageType,
    setIsQuickviewOpen = _ref.setIsQuickviewOpen;
  var triggerQuickView = useCallback(function (event) {
    triggerQuickviewAnalytics({
      algonomyOnClickAnalytics: algonomyOnClickAnalytics,
      categoryId: categoryId,
      isMiniGrid: isMiniGrid,
      socialProofMessage: socialProofMessage
    });
    var quickviewEventOld = new CustomEvent('quickview:openModal', {
      detail: {
        productId: productId,
        collectionId: collection,
        seq: defaultSwatchSequence,
        productName: productName,
        imageId: imageSet.primaryFaceOutImage,
        productBrand: brand,
        faceout: faceoutImageType,
        returnFocus: event.currentTarget,
        origin: isMiniGrid ? 'mini grid' : '',
        categoryId: categoryId !== null && categoryId !== void 0 ? categoryId : '',
        afsource: socialProofMessage ? 'social proofing' : ''
      }
    });
    var quickviewEventNew = new CustomEvent('quickview:mfe:openModal', {
      detail: {
        productId: productId,
        collectionId: collection,
        seq: defaultSwatchSequence,
        returnFocus: event.currentTarget,
        faceout: faceoutImageType
      }
    });

    /**
     * There's a possibility that something goes wrong and the QV doesn't open,
     * which will mess up our state.
     * This is the best we can do since we're not getting any acknowledgement
     * as to whether or not the QV opened in response to our event.
     */
    setIsQuickviewOpen(true);
    try {
      window.digitalData.set('page.pageViewMethod', 'modal-quickview');
      window.digitalData.set('product.productViewMethod', 'navigation-grid');
      var qvEventDispatchTarget = isMfeQuickview ? document : $window;
      qvEventDispatchTarget.dispatchEvent(isMfeQuickview ? quickviewEventNew : quickviewEventOld);
    } catch (error) {
      // TODO: Log this?
      setIsQuickviewOpen(false);
    }
  }, [algonomyOnClickAnalytics, brand, categoryId, collection, defaultSwatchSequence, faceoutImageType, isMfeQuickview, imageSet.primaryFaceOutImage, isMiniGrid, productName, productId, socialProofMessage, setIsQuickviewOpen]);
  return {
    triggerQuickView: triggerQuickView
  };
};var useSwatchHover = function useSwatchHover(_ref) {
  var hasSwatchHover = _ref.hasSwatchHover,
    hoveredSwatchId = _ref.hoveredSwatchId,
    setHoveredSwatch = _ref.setHoveredSwatch,
    hadSwatchInteraction = _ref.hadSwatchInteraction,
    onSwatchInteraction = _ref.onSwatchInteraction;
  var handleSwatchHover = function handleSwatchHover(newHoveredSwatch) {
    var isDifferentSwatch = (newHoveredSwatch === null || newHoveredSwatch === void 0 ? void 0 : newHoveredSwatch.id) !== hoveredSwatchId;

    // Only update state if there is a new swatch
    // This is needed because object comparison (swatch vs swatch) is shallow
    if (!hasSwatchHover && isDifferentSwatch) {
      setHoveredSwatch(newHoveredSwatch);
    }
    if ($window.digitalData && newHoveredSwatch && isDifferentSwatch && !hadSwatchInteraction) {
      triggerHoverAnalytics();
      onSwatchInteraction();
    }
  };
  return {
    handleSwatchHover: handleSwatchHover
  };
};var useSetVisitedProduct = function useSetVisitedProduct(_ref) {
  var kic = _ref.kic,
    productPageUrl = _ref.productPageUrl;
  var _useSessionStorage = useSessionStorage('productToFocus', {}),
    _useSessionStorage2 = _slicedToArray(_useSessionStorage, 2),
    productToFocus = _useSessionStorage2[0],
    setProductToFocus = _useSessionStorage2[1];
  var setHistory = useCallback(function () {
    var historyState = _typeof(window.history.state) === 'object' && !!window.history.state ? window.history.state : {};
    window.history.replaceState(_objectSpread2(_objectSpread2({}, historyState), {}, {
      productToFocus: 'true'
    }), '', window.location.pathname + window.location.search);
  }, []);
  var handleOpenProduct = useCallback(function (event) {
    event.preventDefault();
    setHistory();
    setProductToFocus(_objectSpread2(_objectSpread2({}, productToFocus), {}, {
      productId: kic
    }));
    $window.location.href = productPageUrl;
  }, [kic, productPageUrl, setHistory, productToFocus, setProductToFocus]);
  return {
    handleOpenProduct: handleOpenProduct
  };
};/**
 * ProductCard component renders product cards with images, details, swatches, and action buttons.
 *
 * @param {Object} prop - the props object
 * @param {Object} props.algonomyOnClickAnalytics - Analytics data for Algonomy click events.
 * @param {string} props.brand - the brand
 * @param {string} props.categoryId - The category ID
 * @param {string} props.className - Additional class names for the product card
 * @param {string} props.clickBehavior - The click behavior for the product card
 * @param {boolean} props.deferImageLoad - Whether to defer image loading
 * @param {boolean} props.hasSwatchHover - Whether the swatches have hover functionality
 * @param {boolean} props.hasHyperlinkShortDescriptor - Show/Hide shortdescriptors as hyperlinks
 * @param {boolean} props.hadSwatchInteraction - Whether there was a swatch interaction
 * @param {Function} props.handleSavesClick - Callback for save button click
 * @param {Function} props.handleSwatchClick - Callback for swatch click
 * @param {string} props.imageHostName - The hostname for the product images
 * @param {boolean} props.isDesktop - Whether the view is in desktop or mobile
 * @param {boolean} props.isMiniGrid - Whether the product card is in a mini grid layout
 * @param {boolean} props.isMiniGridSpotlightCard - Checking for mini grid spotlight card
 * @param {boolean} props.isSaved - Whether the product is saved
 * @param {boolean} props.hasModelImagery - Whether the product has model image
 * @param {boolean} props.hasProdImagery - Whether the product has prod image
 * @param {string} props.noImageFoundImgUrl - The URL for the "no image found" placeholder
 * @param {Function} props.onSwatchInteraction - Callback for swatch interaction
 * @param {Object} props.product - The product data
 * @param {Object} props.text - Translated text for the product card
 */
function ProductCard(_ref) {
  var _imageSet$primaryFace, _swatchList$find$name, _swatchList$find;
  var _ref$algonomyOnClickA = _ref.algonomyOnClickAnalytics,
    algonomyOnClickAnalytics = _ref$algonomyOnClickA === void 0 ? {} : _ref$algonomyOnClickA,
    brand = _ref.brand,
    _ref$categoryId = _ref.categoryId,
    categoryId = _ref$categoryId === void 0 ? '' : _ref$categoryId,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    _ref$clickBehavior = _ref.clickBehavior,
    clickBehavior = _ref$clickBehavior === void 0 ? CLICK_BEHAVIORS.productPage : _ref$clickBehavior,
    _ref$deferImageLoad = _ref.deferImageLoad,
    deferImageLoad = _ref$deferImageLoad === void 0 ? true : _ref$deferImageLoad,
    _ref$hasHyperlinkShor = _ref.hasHyperlinkShortDescriptor,
    hasHyperlinkShortDescriptor = _ref$hasHyperlinkShor === void 0 ? false : _ref$hasHyperlinkShor,
    _ref$hasModelImagery = _ref.hasModelImagery,
    hasModelImagery = _ref$hasModelImagery === void 0 ? false : _ref$hasModelImagery,
    _ref$hasProdImagery = _ref.hasProdImagery,
    hasProdImagery = _ref$hasProdImagery === void 0 ? false : _ref$hasProdImagery,
    _ref$hasSwatchHover = _ref.hasSwatchHover,
    hasSwatchHover = _ref$hasSwatchHover === void 0 ? false : _ref$hasSwatchHover,
    _ref$hadSwatchInterac = _ref.hadSwatchInteraction,
    hadSwatchInteraction = _ref$hadSwatchInterac === void 0 ? false : _ref$hadSwatchInterac,
    handleSavesClick = _ref.handleSavesClick,
    handleSwatchClick = _ref.handleSwatchClick,
    _ref$hyperlinkShortDe = _ref.hyperlinkShortDescriptorsFlag,
    hyperlinkShortDescriptorsFlag = _ref$hyperlinkShortDe === void 0 ? false : _ref$hyperlinkShortDe,
    imageHostName = _ref.imageHostName,
    _ref$isDesktop = _ref.isDesktop,
    isDesktop = _ref$isDesktop === void 0 ? false : _ref$isDesktop,
    _ref$isMiniGrid = _ref.isMiniGrid,
    isMiniGrid = _ref$isMiniGrid === void 0 ? false : _ref$isMiniGrid,
    _ref$isMiniGridSpotli = _ref.isMiniGridSpotlightCard,
    isMiniGridSpotlightCard = _ref$isMiniGridSpotli === void 0 ? false : _ref$isMiniGridSpotli,
    _ref$isMfeQuickview = _ref.isMfeQuickview,
    isMfeQuickview = _ref$isMfeQuickview === void 0 ? false : _ref$isMfeQuickview,
    _ref$isSaved = _ref.isSaved,
    isSaved = _ref$isSaved === void 0 ? false : _ref$isSaved,
    noImageFoundImgUrl = _ref.noImageFoundImgUrl,
    _ref$onSwatchInteract = _ref.onSwatchInteraction,
    onSwatchInteraction = _ref$onSwatchInteract === void 0 ? function () {} : _ref$onSwatchInteract,
    _ref$product = _ref.product,
    badges = _ref$product.badges,
    collection = _ref$product.collection,
    defaultSwatchSequence = _ref$product.defaultSwatchSequence,
    departmentName = _ref$product.departmentName,
    productId = _ref$product.id,
    imageSet = _ref$product.imageSet,
    kic = _ref$product.kic,
    memberPrice = _ref$product.memberPrice,
    name = _ref$product.name,
    price = _ref$product.price,
    productPageUrl = _ref$product.productPageUrl,
    promoMessaging = _ref$product.promoMessaging,
    shortDescriptors = _ref$product.shortDescriptors,
    socialProofMessage = _ref$product.socialProofMessage,
    swatchList = _ref$product.swatchList,
    _ref$text = _ref.text,
    elementChangeWarning = _ref$text.elementChangeWarning,
    quickViewLabel = _ref$text.quickViewLabel,
    saveButtonSave = _ref$text.saveButtonSave,
    saveButtonSaved = _ref$text.saveButtonSaved,
    _ref$shouldSetVisited = _ref.shouldSetVisitedProduct,
    shouldSetVisitedProduct = _ref$shouldSetVisited === void 0 ? false : _ref$shouldSetVisited;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isHovered = _useState2[0],
    setIsHovered = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isQuickviewOpen = _useState4[0],
    setIsQuickviewOpen = _useState4[1];
  var _useState5 = useState(null),
    _useState6 = _slicedToArray(_useState5, 2),
    hoveredSwatch = _useState6[0],
    setHoveredSwatch = _useState6[1];
  var faceoutImageType = (_imageSet$primaryFace = imageSet.primaryFaceOutImage) === null || _imageSet$primaryFace === void 0 ? void 0 : _imageSet$primaryFace.replace(/[A-Z\d\-_]/g, '');
  var _useState7 = useState(0),
    _useState8 = _slicedToArray(_useState7, 2),
    height = _useState8[0],
    setHeight = _useState8[1];
  var _useImagePreloading = useImagePreloading(swatchList, imageHostName, imageSet, setIsHovered, setHeight, isDesktop, hasSwatchHover),
    productCardRef = _useImagePreloading.productCardRef,
    setIsHoveredWithImagePreloading = _useImagePreloading.setIsHoveredWithImagePreloading,
    imagesLoaded = _useImagePreloading.imagesLoaded;
  var _useQuickView = useQuickViewEvent({
      algonomyOnClickAnalytics: algonomyOnClickAnalytics,
      brand: brand,
      categoryId: categoryId,
      faceoutImageType: faceoutImageType,
      isMiniGrid: isMiniGrid,
      isMfeQuickview: isMfeQuickview,
      product: {
        collection: collection,
        defaultSwatchSequence: defaultSwatchSequence,
        productId: productId,
        imageSet: imageSet,
        productName: name,
        socialProofMessage: socialProofMessage
      },
      setIsQuickviewOpen: setIsQuickviewOpen
    }),
    triggerQuickView = _useQuickView.triggerQuickView;
  var _useSwatchHover = useSwatchHover({
      hasSwatchHover: hasSwatchHover,
      hadSwatchInteraction: hadSwatchInteraction,
      hoveredSwatchId: hoveredSwatch === null || hoveredSwatch === void 0 ? void 0 : hoveredSwatch.id,
      onSwatchInteraction: onSwatchInteraction,
      setHoveredSwatch: setHoveredSwatch
    }),
    handleSwatchHover = _useSwatchHover.handleSwatchHover;
  var _useSetVisitedProduct = useSetVisitedProduct({
      kic: kic,
      productPageUrl: productPageUrl
    }),
    handleOpenProduct = _useSetVisitedProduct.handleOpenProduct;
  var selectedSwatchName = (_swatchList$find$name = swatchList === null || swatchList === void 0 || (_swatchList$find = swatchList.find(function (swatch) {
    return swatch.product.id === productId;
  })) === null || _swatchList$find === void 0 ? void 0 : _swatchList$find.name) !== null && _swatchList$find$name !== void 0 ? _swatchList$find$name : '';
  var handleCardHover = function handleCardHover(value) {
    // Disable hover functionality for mobile
    if (isDesktop) {
      setIsHoveredWithImagePreloading(value);
    }
  };
  var handleCardFocus = function handleCardFocus() {
    handleCardHover(true);
    setIsQuickviewOpen(false);
  };
  var handleCardBlur = function handleCardBlur(e) {
    /**
     * Consider the card still focused if it or any of its focusable
     * descendants are next to be focused. This is particularly important so
     * that all swatches remain existent/focusable as you tab through them
     */
    handleCardHover(productCardRef.current.contains(e.relatedTarget));
  };
  var handleProductCardClick = function handleProductCardClick(event) {
    if (clickBehavior === CLICK_BEHAVIORS.quickview) {
      event.preventDefault();
      triggerQuickView(event);
    } else if (clickBehavior === CLICK_BEHAVIORS.productPage) {
      if (shouldSetVisitedProduct) {
        handleOpenProduct(event);
      }
      if (isMiniGrid && categoryId) {
        triggerMiniGridAnalytics();
      }
    }
  };
  var showHyperlinkShortDescriptors = !!hasHyperlinkShortDescriptor;
  return /*#__PURE__*/React.createElement("li", {
    ref: productCardRef,
    className: classNames(style.productCard, style[brand], className, _defineProperty(_defineProperty(_defineProperty({}, style.hover, isHovered), miniGridStyle.spotlightCard, isMiniGridSpotlightCard), style.topBadge, socialProofMessage)),
    "data-aui": "product-card",
    "data-intlkic": kic,
    "data-testid": "catalog-product-card",
    onBlur: handleCardBlur,
    onFocus: handleCardFocus,
    onMouseEnter: function onMouseEnter() {
      return handleCardHover(true);
    },
    onMouseLeave: function onMouseLeave() {
      return handleCardHover(false);
    },
    style: {
      maxHeight: isHovered ? height : null
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "".concat(style.template, " product-template")
  }, /*#__PURE__*/React.createElement(SocialProofBadge, {
    brand: brand,
    isDesktop: isDesktop,
    socialProofMessage: socialProofMessage
  }), /*#__PURE__*/React.createElement("div", {
    className: style['product-image-section']
  }, /*#__PURE__*/React.createElement(ProductCardImages, {
    forceLifestyleImage: isMiniGridSpotlightCard,
    hasModelImagery: hasModelImagery,
    hasProdImagery: hasProdImagery,
    hoveredSwatch: hoveredSwatch,
    imageHostName: imageHostName,
    imageSet: imageSet,
    noImageFoundImgUrl: noImageFoundImgUrl,
    onClick: handleProductCardClick,
    productName: name,
    productPageUrl: productPageUrl,
    selectedSwatchName: selectedSwatchName,
    showPlaceholder: deferImageLoad && !imagesLoaded
  }), /*#__PURE__*/React.createElement(ProductCardButtons, {
    isSaved: isSaved,
    onQuickViewClick: triggerQuickView,
    onSaveClick: handleSavesClick,
    showQuickView: !isDesktop || isHovered || isQuickviewOpen,
    isDesktop: isDesktop,
    quickViewLabel: quickViewLabel,
    saveLabel: saveButtonSave,
    savedLabel: saveButtonSaved
  })), /*#__PURE__*/React.createElement("div", {
    className: "".concat(style.content, " product-content")
  }, (swatchList === null || swatchList === void 0 ? void 0 : swatchList.length) > 0 && /*#__PURE__*/React.createElement(ProductSwatches, {
    handleSwatchHover: handleSwatchHover,
    hasSwatchHover: hasSwatchHover,
    elementChangeWarning: elementChangeWarning,
    imageHostName: imageHostName,
    isDesktop: isDesktop,
    limitSwatches: !isHovered,
    productId: productId,
    productName: name,
    productPageUrl: addUrlParameters(productPageUrl, PRODUCT_CARD_SWATCH_URL_ANALYTICS_PARAMETERS),
    handleSwatchClick: handleSwatchClick,
    showPlaceholder: deferImageLoad && !imagesLoaded,
    swatchList: swatchList
  }), /*#__PURE__*/React.createElement(ProductDetailsSection, {
    badges: badges,
    brand: brand,
    departmentName: departmentName,
    handleProductCardClick: handleProductCardClick,
    memberPrice: memberPrice,
    price: price,
    productName: name,
    productPageUrl: productPageUrl,
    promoMessaging: promoMessaging,
    shortDescriptors: shortDescriptors,
    showHyperlinkShortDescriptors: showHyperlinkShortDescriptors,
    hyperlinkShortDescriptorsFlag: hyperlinkShortDescriptorsFlag
  }))));
}
ProductCard.propTypes = productCardProps;/**
 * ProductCardDataWrapper component handles queries for the ProductCard component.
 *
 * @param {Object} prop - the props object
 * @param {Object} props.algonomyOnClickAnalytics - Analytics data for Algonomy click events.
 * @param {string} props.className - Additional class names for the product card
 * @param {string} props.clickBehavior - The click behavior for the product card
 * @param {boolean} props.deferImageLoad - Whether to defer image loading
 * @param {boolean} props.hasSwatchHover - Whether the swatches have hover functionality
 * @param {boolean} props.hasHyperlinkShortDescriptor - Show/Hide shortdescriptors as hyperlinks
 * @param {boolean} props.hadSwatchInteraction - Whether there was a swatch interaction
 * @param {string} props.imageHostName - The hostname for the product images
 * @param {boolean} props.isDesktop - Whether the view is in desktop or mobile
 * @param {boolean} props.isMfeQuickview - Whether the quickview is the new MFE one or not
 * @param {boolean} props.isMiniGrid - Whether the product card is in a mini grid layout
 * @param {boolean} props.isMiniGridSpotlightCard - Checking for mini grid spotlight card
 * @param {boolean} props.hasModelImagery - Whether the product has model image
 * @param {boolean} props.hasProdImagery - Whether the product has prod image
 * @param {Object} props.mySavesItems - The saved items for the user
 * @param {string} props.noImageFoundImgUrl - The URL for the "no image found" placeholder
 * @param {Function} props.onSwatchInteraction - Callback for swatch interaction
 * @param {Object} props.product - The product data
 * @param {Function} props.refetch - Function to refetch the product data
 * @param {string} props.store - The store identifier
 * @param {string} props.storeId - The store ID
 */
function ProductCardDataWrapper(_ref) {
  var _ref$algonomyOnClickA = _ref.algonomyOnClickAnalytics,
    algonomyOnClickAnalytics = _ref$algonomyOnClickA === void 0 ? {} : _ref$algonomyOnClickA,
    brand = _ref.brand,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    _ref$clickBehavior = _ref.clickBehavior,
    clickBehavior = _ref$clickBehavior === void 0 ? CLICK_BEHAVIORS.productPage : _ref$clickBehavior,
    _ref$deferImageLoad = _ref.deferImageLoad,
    deferImageLoad = _ref$deferImageLoad === void 0 ? true : _ref$deferImageLoad,
    _ref$hasHyperlinkShor = _ref.hasHyperlinkShortDescriptor,
    hasHyperlinkShortDescriptor = _ref$hasHyperlinkShor === void 0 ? false : _ref$hasHyperlinkShor,
    _ref$hasModelImagery = _ref.hasModelImagery,
    hasModelImagery = _ref$hasModelImagery === void 0 ? false : _ref$hasModelImagery,
    _ref$hasProdImagery = _ref.hasProdImagery,
    hasProdImagery = _ref$hasProdImagery === void 0 ? false : _ref$hasProdImagery,
    _ref$hasSwatchHover = _ref.hasSwatchHover,
    hasSwatchHover = _ref$hasSwatchHover === void 0 ? false : _ref$hasSwatchHover,
    _ref$hadSwatchInterac = _ref.hadSwatchInteraction,
    hadSwatchInteraction = _ref$hadSwatchInterac === void 0 ? false : _ref$hadSwatchInterac,
    imageHostName = _ref.imageHostName,
    _ref$isDesktop = _ref.isDesktop,
    isDesktop = _ref$isDesktop === void 0 ? false : _ref$isDesktop,
    _ref$isMfeQuickview = _ref.isMfeQuickview,
    isMfeQuickview = _ref$isMfeQuickview === void 0 ? false : _ref$isMfeQuickview,
    _ref$isMiniGrid = _ref.isMiniGrid,
    isMiniGrid = _ref$isMiniGrid === void 0 ? false : _ref$isMiniGrid,
    _ref$isMiniGridSpotli = _ref.isMiniGridSpotlightCard,
    isMiniGridSpotlightCard = _ref$isMiniGridSpotli === void 0 ? false : _ref$isMiniGridSpotli,
    _ref$mySavesItems = _ref.mySavesItems,
    mySavesItems = _ref$mySavesItems === void 0 ? {} : _ref$mySavesItems,
    noImageFoundImgUrl = _ref.noImageFoundImgUrl,
    _ref$onSwatchInteract = _ref.onSwatchInteraction,
    onSwatchInteraction = _ref$onSwatchInteract === void 0 ? function () {} : _ref$onSwatchInteract,
    product = _ref.product,
    _ref$refetch = _ref.refetch,
    refetch = _ref$refetch === void 0 ? function () {} : _ref$refetch,
    store = _ref.store,
    storeId = _ref.storeId,
    shouldSetVisitedProduct = _ref.shouldSetVisitedProduct;
  var _useLazyQuery = useLazyQuery(getProductDataQuery, {
      ssr: false,
      onCompleted: function onCompleted(data) {
        window.location.assign(addUrlParameters(data.product.productPageUrl, PRODUCT_CARD_SWATCH_URL_ANALYTICS_PARAMETERS));
      }
    }),
    _useLazyQuery2 = _slicedToArray(_useLazyQuery, 1),
    getProductData = _useLazyQuery2[0];
  var handleSwatchClick = function handleSwatchClick(swatchId) {
    if (swatchId === product.id) {
      window.location.assign(addUrlParameters(product.productPageUrl, PRODUCT_CARD_SWATCH_URL_ANALYTICS_PARAMETERS));
    } else {
      getProductData({
        variables: {
          productId: swatchId
        }
      });
    }
  };
  var productId = product.id,
    kic = product.kic,
    collection = product.collection,
    defaultSwatchSequence = product.defaultSwatchSequence,
    price = product.price,
    categoryId = product.categoryId,
    name = product.name;
  var _useUpdateMySaves = useUpdateMySaves({
      productId: productId,
      kic: kic,
      collectionId: collection,
      swatchSequence: defaultSwatchSequence,
      longsku: '',
      colorCode: defaultSwatchSequence,
      price: price,
      brand: brand,
      categoryId: categoryId,
      name: name,
      isMiniGrid: isMiniGrid,
      mySavesItems: mySavesItems,
      refetch: refetch,
      store: store,
      storeId: storeId
    }),
    handleSavesClick = _useUpdateMySaves.handleSavesClick,
    isSaved = _useUpdateMySaves.isSaved;
  var text = {
    elementChangeWarning: useTranslatedText('elementChangeWarning', {
      fallback: 'Activating this element will cause content on the page to be updated.'
    }),
    quickViewLabel: useTranslatedText('quickview', {
      fallback: 'Quickview'
    }),
    saveButtonSave: useTranslatedText('saveButtonSave', {
      fallback: 'Save'
    }),
    saveButtonSaved: useTranslatedText('saveButtonSaved', {
      fallback: 'Saved'
    })
  };
  return /*#__PURE__*/React.createElement(ProductCard, {
    algonomyOnClickAnalytics: algonomyOnClickAnalytics,
    brand: brand,
    categoryId: categoryId,
    className: className,
    clickBehavior: clickBehavior,
    deferImageLoad: deferImageLoad,
    hadSwatchInteraction: hadSwatchInteraction,
    handleSavesClick: handleSavesClick,
    handleSwatchClick: handleSwatchClick,
    hasHyperlinkShortDescriptor: hasHyperlinkShortDescriptor,
    hasModelImagery: hasModelImagery === 'model',
    hasProdImagery: hasProdImagery,
    hasSwatchHover: hasSwatchHover,
    imageHostName: imageHostName,
    isDesktop: isDesktop,
    isMfeQuickview: isMfeQuickview,
    isMiniGrid: isMiniGrid,
    isMiniGridSpotlightCard: isMiniGridSpotlightCard,
    isSaved: isSaved,
    noImageFoundImgUrl: noImageFoundImgUrl,
    onSwatchInteraction: onSwatchInteraction,
    product: product,
    shouldSetVisitedProduct: shouldSetVisitedProduct,
    text: text
  });
}
ProductCardDataWrapper.propTypes = productCardDataWrapperProps;export{ProductCardDataWrapper as default};//# sourceMappingURL=index.js.map
